import * as joint from '@clientio/rappid';
import { generateCustomObjects } from '../shapes/custom-objects';
import { toast } from 'react-toastify';
import FlowireAPI from '../../../flowireapi/FlowireAPI';
import { updateLinksWithAgMatrix } from './adgacencyMatrix/adgacencyMatrixService';
import UnitNumberingService from './unitNumberingService/unitNumbering';
import TextOverlayManager from '../../Simulator/services/TextOverlayManager.js';


class KitchenSinkService {
    constructor(el, toolbarService, navigate, displayRXSpecPopup, displayFeedTagPopup, toggleSaveNamePopup, isAuthenticated, getIdTokenClaims, useSimulator, setGraphData, openConfirmPopup, hasUpdated, isUpdated, displayEquipmentPropPopup, graphGroup, orgSectors){
        this.openConfirmPopup = openConfirmPopup
        this.hasUpdated = hasUpdated
        this.isUpdated = isUpdated
        this.setGraphData = setGraphData
        this.el = el;
        this.toolbarService = toolbarService;
        this.navigate = navigate
        this.stream_Count = 1
        this.displayRXSpecPopup = displayRXSpecPopup
        this.displayFeedTagPopup = displayFeedTagPopup
        this.toggleSaveNamePopup = toggleSaveNamePopup
        this.isAuthenticated = isAuthenticated
        this.getIdTokenClaims = getIdTokenClaims
        this.useSimulator = useSimulator
        this.displayEquipmentPropPopup = displayEquipmentPropPopup
        this.graphGroup = graphGroup
        this.orgSectors = orgSectors
        this.unitNumberingService = null;
    }

    startRappid = () => {
        this.initializePaper();
        this.initializeSelection();
        this.initializeToolsAndInspector();
        this.initializeToolbar();
        this.initializeKeyboardShortcuts();
        this.initializeStencil();
        // Set up the context value
    }

    stopRappid = () => {
        this.paper.remove();
        this.paperScroller.remove();
        this.selection.remove();
        this.toolbarService.toolbar.remove();
        this.keyboard.stopListening();
    }

    initializePaper = () => {
        const graph = this.graph = new joint.dia.Graph({}, { cellNamespace: joint.shapes});

        //initialize the unit numbering service
        this.unitNumberingService = new UnitNumberingService(graph);

        joint.shapes.standard.LinkView = joint.dia.LinkView.extend({

            events: {
                'change input': 'onInputChange',
                'blur input': 'onInputBlur'
            },

            onInputChange: (evt) => {
                var input = evt.target;
                let label_Value = evt.target.value
                let modelId = input.getAttribute('id').split('labelInputDiv')[0]
                let model = this.graph.getCell(modelId)
                if (!(this.stream_Number_Verification(label_Value, model.id))) {
                    alert("Sorry, a stream with this number already exists!");
                    evt.target.value = model.prop('CustomName')
                    return
                }
                model.label(0, { attrs: { 'labelInputDiv': { value: label_Value } } });
                model.prop('CustomName', label_Value)
                model.prop('stream_Number', label_Value)
                // The main purpose of this is to hide the label if they clear the number
                if (label_Value == "" || label_Value == null) {
                    // Hide the label if it's emptied
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderBottom: 'hidden' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderTop: 'hidden' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderLeft: 'hidden' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderRight: 'hidden' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { backgroundColor: 'transparent' } } } });
                }
                else {
                    // Show label borders/fill again if the text has content in it
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderBottom: '1px solid black' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderTop: '1px solid black' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderLeft: '1px solid black' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderRight: '1px solid black' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { backgroundColor: 'white' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { width: String(label_Value.length * 6 + 10) + "px" } } } });
                    if (!(isNaN(label_Value))) {
                        this.stream_Count = parseInt(label_Value)
                        this.stream_Count += 1
                    }
                }
            },
            onInputBlur: function (evt) {
                var input = evt.target;
                let label_Value = evt.target.value
                if (label_Value == "" || label_Value == null) {
                    // Hide the label if it's emptied
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderBottom: 'hidden' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderTop: 'hidden' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderLeft: 'hidden' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { borderRight: 'hidden' } } } });
                    model.label(0, { attrs: { 'labelInputDiv': { style: { backgroundColor: 'transparent' } } } });
                }
            }
        });

        generateCustomObjects(joint);


        var paper = this.paper = new joint.dia.Paper({
            width: 1587,
            height: 1123,
            gridSize: 5,
            cellViewNamespace: joint.shapes,
            drawGrid: {
                name: 'doubleMesh',
                args: [
                    { color: '#f6f6f6', thickness: 1 }, // settings for the primary mesh
                    { color: '#e0e0e0', scaleFactor: 10, thickness: 2 } //settings for the secondary mesh
                ]
            },
            background: { color: 'white' },
            model: graph, // Set graph as the model for paper
            defaultLink: function (elementView, magnet) {
                return new joint.shapes.standard.Link({
                    attrs: {
                        line: { stroke: 'black', strokeWidth: 1 },
                    },
                    // must be set this way, default router options setting doesn't work
                    router: { name: 'manhattan', padding: 10, step: 10 
                    }
                });
            },
            //defaultRouter: { name: 'manhattan',padding:50},
            interactive: {
                linkMove: false,
                vertexMove: false
            },
            snapLinks: { radius: 50 },
            snapLabels: true,
            linkPinning: false,
            defaultConnectionPoint: { name: 'anchor' },
            defaultAnchor: { name: 'perpendicular' },
            guard: function (evt) {
                //console.log(evt)
                if (evt.target.parentNode != null) {
                    return (evt.target.getAttribute('class') != null && ((evt.target.getAttribute('class').indexOf('shapename')) !== -1 || ((evt.target.getAttribute('class')).indexOf('ql')) !== -1) || (evt.target.parentNode.getAttribute('class') != null && evt.target.parentNode.getAttribute('class').indexOf('ql')) !== -1 || (evt.target instanceof HTMLTextAreaElement || evt.target instanceof HTMLInputElement));
                }
            },
            validateConnection: function (cellViewS, magnetS, cellViewT, magnetT, end, linkView) {
                if (cellViewS == cellViewT) return false;
                return (magnetT)
            },
            validateMagnet: function (cellView, magnet) {
                // Prevent links from ports that are labelled with 'in'
                //if (magnet.getAttribute('port').includes("in")) return false;
                var port = magnet.getAttribute('port');
                var links = graph.getConnectedLinks(cellView.model, { outbound: true });
                //code below is to stop multiple links from a source port
                var portLinks = _.filter(links, function (o) {
                    return o.get('source').port == port;
                });
                if (portLinks.length > 0) return false;
                // Note that this is the default behaviour. Just showing it here for reference.
                // Disable linking interaction for magnets marked as passive (see below `.inPorts circle`).
                if (cellView.model.prop('unitType') == 'pipework') {
                    if (magnet.getAttribute('port') == 'out_top_1') {
                        cellView.model.attr('topline/stroke', 'black')
                    }
                    if (magnet.getAttribute('port') == 'out_bottom_1') {
                        cellView.model.attr('bottomline/stroke', 'black')
                    }
                    if (magnet.getAttribute('port') == 'out_right_1') {
                        cellView.model.attr('rightline/stroke', 'black')

                    }
                    if (magnet.getAttribute('port') == 'out_left_1') {
                        cellView.model.attr('leftline/stroke', 'black')
                    }
                    cellView.model.attr('crosshairs/stroke', 'none')
                    cellView.model.attr('body/stroke', 'none')
                    cellView.model.attr('body/fill', 'transparent')
                }
                return magnet.getAttribute('magnet') !== 'passive';
            }
            //ORIGINALLY defaultConnectionPoint: { name: 'boundary' }
        });

        var commandManager = this.commandManager = new joint.dia.CommandManager({
            graph: graph,
            cmdBeforeAdd: function (cmdName, cell, graph, options) {
                options = options || {};
                return !options.ignoreCommandManager;
            }
        });

        var paperScroller = this.paperScroller = new joint.ui.PaperScroller({
            paper: paper,
            autoResizePaper: false,
            cursor: 'grab',
            scrollWhileDragging: true
        });
        this.renderPlugin('.paperContainer', paperScroller);
        paperScroller.render();
        paperScroller.zoomToRect({ x: 0, y: 0, width: 1587, height: 1123 }) // zoom to fill screen might need to be refined
        paperScroller.center();
        paperScroller.zoom(0.1); // zoom to fill screen
        this.baseline_Zoom = paperScroller.zoom();

        // Initialize text overlay manager for detached Quill editors
        this.textOverlayManager = new TextOverlayManager(paper, paperScroller, graph);

        paper.on('blank:pointerdown', (evt, x, y) => {
            if(!this.toolbarService) return;
            if(!this.toolbarService.selectedTool) this.toolbarService.selectedTool = 'pan';
            if (this.toolbarService.selectedTool != 'pan') return;
            evt.preventDefault();
            paperScroller.setCursor('grab');
            paperScroller.startPanning(evt)
        });

        paper.on('blank:pointerup', (evt, x, y) => {
            paperScroller.setCursor('default');

        });

        paper.on('blank:mouseover', () => {
            paperScroller.setCursor('default');

        })
        paper.on('blank:pointerdown cell:pointerdown', () => {
            document.activeElement.blur();
            window.getSelection().empty()
        });

        this.snaplines = new joint.ui.Snaplines({
            paper: paper,
            filter: function (element) {
                // exclude the title block for snapping
                if (element.attributes.type.search('dwgtemplate') != -1)
                    return true
            }
        })

      paperScroller.lock()

      // Halo
      // ----

      paper.on('element:pointerup', (elementView) => {
          this.createPointerHalo(elementView)
          var freeTransform = new joint.ui.FreeTransform({ cellView: elementView });
          freeTransform.render();
      });

      // Link Tools
      // ----------
      paper.on('blank:mousewheel', (evt, x, y, delta) => {
          //console.log(delta)
          if (delta > 0) {
              paperScroller.zoom(0.1, { max: 1.4, grid: 0.1 });
              paperScroller.setCursor('zoom-in')
          }
          else {
              paperScroller.zoom(-0.1, {  grid: 0.1 });
              paperScroller.setCursor('zoom-out')
              if (paperScroller.zoom() <= this.baseline_Zoom) {
                  paperScroller.center();
                  this.baseline_Zoom = paperScroller.zoom()
              }
          }
          // Update text overlay positions after zoom
          if (this.textOverlayManager) {
              this.textOverlayManager.onZoom();
          }
      })
      paper.on('cell:mousewheel', (cellView, evt, x, y, delta) => {
          //console.log(delta)
          if (delta > 0) {
              paperScroller.zoom(0.1, { max: 1.4, grid: 0.1 });
              paperScroller.setCursor('zoom-in')

          }
          else {
              paperScroller.zoom(-0.1, {  grid: 0.1 });
              paperScroller.setCursor('zoom-out')
              if (paperScroller.zoom() <= this.baseline_Zoom) {
                  paperScroller.center();
                  this.baseline_Zoom = paperScroller.zoom()
                  // paperScroller.center({ padding: { top: 20 } })
              }
          }
          // Update text overlay positions after zoom
          if (this.textOverlayManager) {
              this.textOverlayManager.onZoom();
          }
      })

      paper.on('link:change', () => {
        this.hasUpdated(true)
        alert('link changed')
    })

      paper.on('blank:pointerdown', () => {

          paper.removeTools();

          let all_Links = graph.getLinks();
          for (let i = 0; i < all_Links.length; i++) {
              //console.log(paper.findViewByModel(all_Links[i]).getSerializedConnection())
              paper.findViewByModel(all_Links[i]).removeRedundantLinearVertices()
          }

      });

      paper.on('link:pointerdblclick', (cellView, evt, x, y) => {
        this.hasUpdated(true)
          cellView.model.label(0, { attrs: { 'labelInputDiv': { style: { borderBottom: '1px solid black' } } } });
          cellView.model.label(0, { attrs: { 'labelInputDiv': { style: { borderTop: '1px solid black' } } } });
          cellView.model.label(0, { attrs: { 'labelInputDiv': { style: { borderLeft: '1px solid black' } } } });
          cellView.model.label(0, { attrs: { 'labelInputDiv': { style: { borderRight: '1px solid black' } } } });
          cellView.model.label(0, { attrs: { 'labelInputDiv': { style: { backgroundColor: 'white' } } } });
          cellView.model.label(0, { position: { distance: cellView.getClosestPointRatio({ x: x, y: y }) } });
      })

      let left_border_shape = new joint.shapes.dwgtemplate.sideBorderShape();
      let right_border_shape = new joint.shapes.dwgtemplate.sideBorderShape();
      let top_border_shape = new joint.shapes.dwgtemplate.topBorderShape();
      let bottom_border_shape = new joint.shapes.dwgtemplate.topBorderShape();
      left_border_shape.position(0, 0)
      right_border_shape.position(1586-1, 0)
      top_border_shape.position(0, 0)
      bottom_border_shape.position(0, 1122)

      // Add to graph
      graph.addCells(left_border_shape, right_border_shape, top_border_shape, bottom_border_shape)
    }

    createPointerHalo = (elementView) => {
        //selection.collection.add(elementView.model);

        let listed_RX_Types = [
          'bfd.RectangleQuillObject',
          'pfd.VesselObject',
          'pfd.agitatedVesselObject',
          'pfd.membraneObject',
          'pfd.electroWinningHatchedObject',
          'pfd.electroWinningObject',
          'pfd.electrolyserStackObject',
          'pfd.SettlerObject',
          'pfd.OpenVesselObject',
          'pfd.SteamGenObject',
          'pfd.DualDiamVesselObject',
          'pfd.FixedBedColumnObject',
          'pfd.FurnaceObject',
          'pfd.FurnaceHXObject',
          'pfd.DualDiamPackedVesselObject',
          'pfd.pyroRxObject',
          'pfd.WaterWashColumnObject',
          'pfd.ballMillObject'
        ]

        var handles = [/*{
                    name: 'remove',
                    position: 'nw',
                    events: { pointerdown: 'removeElement' }
                }, */{
                name: 'myCustomAction',
                position: 'ne',
                icon: 'data:image/svg+xml;base64,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'
            }];

        if(listed_RX_Types.includes(elementView.model.attributes.type)){
          handles.push({
              name: 'myCustomAction2',
              position: 'nw',
              icon: 'data:image/svg+xml;base64,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'
          })
        }
        if(elementView.model.attributes.unitType == "Feed"){
            // create a handle for the feed tag with the letter A
            handles.push({
                name: 'myCustomActionF',
                position: 'nw',
                icon: 'data:image/svg+xml;base64,' + btoa('<?xml version="1.0" encoding="UTF-8"?>' +
                '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">' +
                '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="265px" height="265px" viewBox="-0.5 -0.5 265 265" xml:space="preserve">' +
                '<defs/>' +
                '<g>' +
                '<ellipse cx="132" cy="132" rx="125" ry="125" fill="rgb(255,255,255)" stroke="#696b8a" stroke-width="15" pointer-events="all"/>' +
                '<g transform="translate(0.5,0.5)">' +
                '<switch>' +
                '<foreignObject pointer-events="none" width="100%" height="100%" requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility" style="overflow: visible; text-align: left;">' +
                '<div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: unsafe center; justify-content: unsafe center; width: 248px; height: 1px; padding-top: 132px; margin-left: 8px;">' +
                '<div style="box-sizing: border-box; font-size: 0px; text-align: center;">' +
                '<div style="display: inline-block; font-size: 153px; font-family: Georgia; color: #696b8a; line-height: 1.2; pointer-events: all; white-space: nowrap;">' +
                "A" +
                '</div>' +
                '</div>' +
                '</div>' +
                '</foreignObject>' +
                '<text x="132" y="136" fill="rgb(0, 0, 0)" font-family="Helvetica" font-size="12px" text-anchor="middle">' +
                "A" +
                '</text>' +
                '</switch>' +
                '</g>' +
                '</g>' +
                '</svg>')
            });
        }
        /*if (!elementView.model.hasPorts()) {
            // Only shapes without ports will have the "link" handle in the Halo control panel. Shapes with ports can be connected by "dragging" ports.
            handles.push({
                name: 'link',
                position: 'e',
                events: { pointerdown: 'startLinking', pointermove: 'doLink', pointerup: 'stopLinking' }
            });
        }*/
        var halo = new joint.ui.Halo({
            cellView: elementView,
            handles: handles,
            useModelGeometry: true,
            boxContent: false,
            tinyThreshold: 1,
            smallThreshold: 5
        }).render();
        halo.on('action:myCustomAction:pointerdown', (evt) => {
          this.hasUpdated(true)
          this.equipment_Property_Popup(elementView.model.id)
            //console.log(elementView.model.attr('shapename/innerHTML'))
            //console.log('hi')

            //alert('My Control Button Clicked!\n' + elementView.model.id + '\n' + elementView.model.attr('shapename/innerHTML'));
        });

        halo.on('action:myCustomAction2:pointerdown', (evt) => {
          this.hasUpdated(true)
          this.RX_Spec_Wizard(this.graph.getCell(elementView.model.id))
        })

        halo.on('action:myCustomActionF:pointerdown', (evt) => {
          this.feed_Tag_Wizard(this.graph.getCell(elementView.model.id), "Feed")
          this.createPointerHalo(elementView)
        })
    }

    initializeStencil = () => {
        joint.shapes.bfd.StencilRectangleQuillObject = joint.shapes.bfd.RectangleQuillObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.bfd.StencilTextBlockObject = joint.shapes.bfd.textBlockObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.bfd.StencilTrapObject = joint.shapes.bfd.TrapObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        // For the pfd shapes
        joint.shapes.pfd.StencilCircleObject = joint.shapes.pfd.CircleObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilFeedObject = joint.shapes.pfd.FeedObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilPumpObject = joint.shapes.pfd.PumpObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        // Continuing with the other shapes
        joint.shapes.pipework.StencilMixerSplitterObject = joint.shapes.pipework.MixerSplitterObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilVesselObject = joint.shapes.pfd.VesselObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilagitatedVesselObject = joint.shapes.pfd.agitatedVesselObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilElectroWinningHatchedObject = joint.dia.Element.define('pfd.electroWinningHatchedObject', {
          size: { width: 80, height: 80 },
          ports: {
            groups: {
              'in': {
                position: {
                  name: 'absolute',
                  args: {}
                }
              },
              'out': {
                position: {
                  name: 'absolute',
                  args: {}
                }
              },
            },
            items: [
              { group: 'in', args: { x: '0%', y: '35%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '0%', y: '60%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '0%', y: '85%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '46%', y: '100%' }, id: 'in_bottom_4', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '35%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '60%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '85%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '54%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
            ]
          },
          portMarkup: [{
            tagName: 'circle',
            selector: 'portBody',
            className: 'magnetTrial',
            attributes: {
              fill: '#FF7597',
              stroke: 'null',
              opacity: 0,
              r: 6
            }
          }],
          attrs: {
            body: {
              refD: 'M 0 0 M 3.5 0 L 3.5 8 M 4.5 0 L 4.5 8 L 3.5 8 L 3.5 0 L 4.5 0 M 4 0 L 3.5 0.5 M 4.5 0 L 3.5 1 M 4.5 0.5 L 3.5 1.5 M 4.5 1 L 3.5 2 M 4.5 1.5 L 3.5 2.5 M 4.5 2 L 3.5 3 M 4.5 2.5 L 3.5 3.5 M 4.5 3 L 3.5 4 M 4.5 3.5 L 3.5 4.5 M 4.5 4 L 3.5 5 M 4.5 4.5 L 3.5 5.5 M 4.5 5 L 3.5 6 M 4.5 5.5 L 3.5 6.5 M 4.5 6 L 3.5 7 M 4.5 6.5 L 3.5 7.5 M 4.5 7 L 3.5 8 M 4.5 7.5 L 4 8 M 8 0 M 0 0 L 0 8 M 0 0 L 8 0 M 8 8 L 8 0 M 0 8 L 8 8 M 3.5 -2.5 L 3.5 -1.5 M 3.5 -2 L 1.75 -2 M 1.75 1.5 L 1.75 -2 M 1.25 1.5 L 2.25 1.5 L 2.25 6 L 1.25 6 L 1.25 1.5 M 4.5 -2 L 4.5 -2.25 M 4.5 -1.75 L 4.5 -2 M 6.25 1.5 L 6.25 -2 M 6.25 -2 L 4.5 -2 M 5.75 1.5 L 5.75 6 L 6.75 6 L 6.75 1.5 L 5.75 1.5',
              stroke: 'black',
              fill: 'transparent'
            },
            forbody: {
              refD: 'M 0 0 L 8 0 L 8 8 L 0 8 Z',
              stroke: 'transparent',
              fill: 'transparent'
            }
          },
          markup: [{
            tagName: 'path',
            selector: 'body',
            className: 'elementBody'
          },
          {
            tagName: 'path',
            selector: 'forbody'
          }
      ]
        }, {
          attributes: {
            innerHTML: {
              set: function (html, _, node) {
                if ('innerHTML' in node) {
                  node.innerHTML = html;
                }
              }
            },
            value: {
              set: function (text, _, node) {
                if ('value' in node) {
                  node.value = text;
                }
              }
            },
            style: {
              display: {
                set: function (styleDisplay, _, node) {
                  if ('display' in node) {
                    node.style.display = styleDisplay;
                  }
                }
              },
              top: {
                set: function (styleTop, _, node) {
                  if ('top' in node) {
                    node.style.top = styleTop;
                  }
                }
              },
              left: {
                set: function (styleLeft, _, node) {
                  if ('left' in node) {
                    node.style.left = styleLeft;
                  }
                }
              },
              width: {
                set: function (styleWidth, _, node) {
                  if ('width' in node) {
                    node.style.width = styleWidth;
                  }
                }
              },
              height: {
                set: function (styleHeight, _, node) {
                  if ('height' in node) {
                    node.style.height = styleHeight;
                  }
                }
              }
            }
          }
        });
        joint.shapes.pfd.StencilElectrolyserStackObject = joint.dia.Element.define('pfd.electrolyserStackObject', {
          size: { width: 80, height: 80 },
          ports: {
            groups: {
              'in': {
                position: {
                  name: 'absolute',
                  args: {}
                }
              },
              'out': {
                position: {
                  name: 'absolute',
                  args: {}
                }
              },
            },
            items: [
              { group: 'in', args: { x: '0%', y: '35%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '0%', y: '60%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '0%', y: '85%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '46%', y: '100%' }, id: 'in_bottom_4', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '35%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '60%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '85%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '54%', y: '100%' }, id: 'out_bottom_4', attrs: { portBody: { magnet: 'true' } } },
            ]
          },
          portMarkup: [{
            tagName: 'circle',
            selector: 'portBody',
            className: 'magnetTrial',
            attributes: {
              fill: '#FF7597',
              stroke: 'null',
              opacity: 0,
              r: 6
            }
          }],
          attrs: {
            body: {
              refD: 'M 0 0 L 4 0 L 4 -18 L 0 -18 M 0 -18 L 0 0 M 4 -16 L 24 -16 L 24 -16 L 24 -2 L 4 -2 M 4 -2 L 4 -2 L 4 -2 L 4 -2 M 24 -18 L 28 -18 L 28 0 L 24 0 L 24 -18 M 6 -16 L 6 -2 M 8 -16 L 8 -2 M 10 -16 L 10 -2 M 12 -16 L 12 -2 M 14 -16 L 14 -2 M 16 -16 L 16 -2 M 18 -16 L 18 -2 M 20 -16 L 20 -2 M 22 -16 L 22 -2 M 2 -3 L 2 -1 M 1 -2 L 3 -2 M 25 -2 L 27 -2',
              stroke: 'black',
              fill: 'transparent'
            },
            forbody: {
              refD: 'M 0 0 L 8 0 L 8 8 L 0 8 Z',
              stroke: 'transparent',
              fill: 'transparent'
            }
          },
          markup: [{
            tagName: 'path',
            selector: 'body',
            className: 'elementBody'
          },
          {
            tagName: 'path',
            selector: 'forbody'
          }
      ]
        }, {
          attributes: {
            innerHTML: {
              set: function (html, _, node) {
                if ('innerHTML' in node) {
                  node.innerHTML = html;
                }
              }
            },
            value: {
              set: function (text, _, node) {
                if ('value' in node) {
                  node.value = text;
                }
              }
            },
            style: {
              display: {
                set: function (styleDisplay, _, node) {
                  if ('display' in node) {
                    node.style.display = styleDisplay;
                  }
                }
              },
              top: {
                set: function (styleTop, _, node) {
                  if ('top' in node) {
                    node.style.top = styleTop;
                  }
                }
              },
              left: {
                set: function (styleLeft, _, node) {
                  if ('left' in node) {
                    node.style.left = styleLeft;
                  }
                }
              },
              width: {
                set: function (styleWidth, _, node) {
                  if ('width' in node) {
                    node.style.width = styleWidth;
                  }
                }
              },
              height: {
                set: function (styleHeight, _, node) {
                  if ('height' in node) {
                    node.style.height = styleHeight;
                  }
                }
              }
            }
          }
        });
        joint.shapes.pfd.StencilElectroWinningObject = joint.dia.Element.define('pfd.electroWinningObject', {
          size: { width: 80, height: 80 },
          ports: {
            groups: {
              'in': {
                position: {
                  name: 'absolute',
                  args: {}
                }
              },
              'out': {
                position: {
                  name: 'absolute',
                  args: {}
                }
              },
            },
            items: [
              { group: 'in', args: { x: '0%', y: '35%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '0%', y: '60%' }, id: 'in_left_2', attrs: { portBody: { magnet: 'true' } } },
              { group: 'in', args: { x: '0%', y: '85%' }, id: 'in_left_3', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '35%' }, id: 'out_right_1', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '60%' }, id: 'out_right_2', attrs: { portBody: { magnet: 'true' } } },
              { group: 'out', args: { x: '100%', y: '85%' }, id: 'out_right_3', attrs: { portBody: { magnet: 'true' } } },
            ]
          },
          portMarkup: [{
            tagName: 'circle',
            selector: 'portBody',
            className: 'magnetTrial',
            attributes: {
              fill: '#FF7597',
              stroke: 'null',
              opacity: 0,
              r: 6
              // If all the magnets are `true` / `passive` feel free to define
              // the magnet here in the default port markup or per a port group
              // 'magnet': true
            }
          }],
          attrs: {
            body: {
              refD: 'M 0 0 L 0 8 M 0 0 L 8 0 M 8 8 L 8 0 M 0 8 L 8 8 M 3.5 -2.5 L 3.5 -1.5 M 3.5 -2 L 1.75 -2 M 1.75 1.5 L 1.75 -2 M 1.25 1.5 L 2.25 1.5 L 2.25 6 L 1.25 6 L 1.25 1.5 M 4.5 -2 L 4.5 -2.25 M 4.5 -1.75 L 4.5 -2 M 6.25 1.5 L 6.25 -2 M 6.25 -2 L 4.5 -2 M 5.75 1.5 L 5.75 6 L 6.75 6 L 6.75 1.5 L 5.75 1.5',
              stroke: 'black',
              fill: 'transparent'
            },
            forbody: {
              refD: 'M 0 0 L 8 0 L 8 8 L 0 8 Z',
              stroke: 'transparent',
              fill: 'transparent'
            },
            foreignObjectAnode: {
              refWidth: '100%',
              refHeight: '100%',
              ref: 'body',
              refX: '58%',
              refY: '85%'
            },
            foreignObjectCathode: {
              refWidth: '100%',
              refHeight: '100%',
              ref: 'body',
              refX: '2%',
              refY: '85%'
            }
          },
          markup: [{
            tagName: 'path',
            selector: 'body',
            className: 'elementBody'
          },
          {
            tagName: 'path',
            selector: 'forbody'
          },
          {
            tagName: 'foreignObject',
            selector: 'foreignObjectAnode',
            className: 'foreignObjectclass',
            style: {
              'overflow': 'visible',
              pointerEvents: 'none'
            },
            children: [{
                tagName: 'input',
                namespaceURI: 'http://www.w3.org/1999/xhtml',
                selector: 'anodeInput',
                className: 'shape-input-div',
                attributes: {
                  'name': 'anodeInput',
                  'overflow': 'visible',
                },
                style: {
                  width: '37%',
                  pointerEvents: 'auto'
                }
        }]}
          ,{
            tagName: 'foreignObject',
            selector: 'foreignObjectCathode',
            className: 'foreignObjectclass',
            style: {
              'overflow': 'visible',
              pointerEvents: 'none',

            },
            children: [{
                tagName: 'input',
                namespaceURI: 'http://www.w3.org/1999/xhtml',
                selector: 'cathodeInput',
                className: 'shape-input-div',
                attributes: {
                  'name': 'cathodeInput',
                  'overflow': 'visible',
                },
                style: {
                  width: '37%',
                  pointerEvents: 'auto'
                }
        }]}
        ]
        } , {
          attributes: {
            innerHTML: {
              set: function (html, _, node) {
                if ('innerHTML' in node) {
                  node.innerHTML = html;
                }
              }
            },
            value: {
              set: function (text, _, node) {
                if ('value' in node) {
                  node.value = text;
                }
              }
            },
            style: {
              display: {
                set: function (styleDisplay, _, node) {
                  if ('display' in node) {
                    node.style.display = styleDisplay;
                  }
                }
              },
              top: {
                set: function (styleTop, _, node) {
                  if ('top' in node) {
                    node.style.top = styleTop;
                  }
                }
              },
              left: {
                set: function (styleLeft, _, node) {
                  if ('left' in node) {
                    node.style.left = styleLeft;
                  }
                }
              },
              width: {
                set: function (styleWidth, _, node) {
                  if ('width' in node) {
                    node.style.width = styleWidth;
                  }
                }
              },
              height: {
                set: function (styleHeight, _, node) {
                  if ('height' in node) {
                    node.style.height = styleHeight;
                  }
                }
              }
            }
          }
        });

        joint.shapes.pfd.StencilHeatXObject = joint.shapes.pfd.HeatXObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilSettlerObject = joint.shapes.pfd.SettlerObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilFilter3Object = joint.shapes.pfd.Filter3Object.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilFilter4Object = joint.shapes.pfd.Filter4Object.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilFilter5Object = joint.shapes.pfd.Filter5Object.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilFilter6Object = joint.shapes.pfd.Filter6Object.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilmembraneObject = joint.shapes.pfd.membraneObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilOpenVesselObject = joint.shapes.pfd.OpenVesselObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        //crusher stencil
        joint.shapes.pfd.StencilcrusherObject = joint.shapes.pfd.crusherObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });


        joint.shapes.pfd.StencilTruckObject = joint.shapes.pfd.TruckObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        //factory stencil
        joint.shapes.pfd.StencilfactoryObject = joint.shapes.pfd.factoryObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        //comminution stencil
        joint.shapes.pfd.StencilcomminutionObject = joint.shapes.pfd.comminutionObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        //haulage stencil
        joint.shapes.pfd.StencilhaulageObject = joint.shapes.pfd.haulageObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        //ballMill stencil
         joint.shapes.pfd.StencilballMillObject = joint.shapes.pfd.ballMillObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilFlareObject = joint.shapes.pfd.FlareObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilHeatXMObject = joint.shapes.pfd.HeatXMObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pid.StencilTPObject = joint.shapes.pid.TPObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pid.StencilControllerObject = joint.shapes.pid.ControllerObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilSteamGenObject = joint.shapes.pfd.SteamGenObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilDualDiamVesselObject = joint.shapes.pfd.DualDiamVesselObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilFixedBedColumnObject = joint.shapes.pfd.FixedBedColumnObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilCompressorObject = joint.shapes.pfd.CompressorObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilVacuumPumpISOObject = joint.shapes.pfd.VacuumPumpISOObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilLiquidPumpISOObject = joint.shapes.pfd.LiquidPumpISOObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilTurbineISOObject = joint.shapes.pfd.TurbineISOObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilInsulatedConeObject = joint.shapes.pfd.InsulatedConeObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilCrusherConeTypeISOObject = joint.shapes.pfd.CrusherConeTypeISOObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilSolidSeparatorObject = joint.shapes.pfd.SolidSeparatorObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilHxEnFinnedTubeFanISOObject = joint.shapes.pfd.HxEnFinnedTubeFanISOObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilFurnaceObject = joint.shapes.pfd.FurnaceObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilFurnaceHXObject = joint.shapes.pfd.FurnaceHXObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilDualDiamPackedVesselObject = joint.shapes.pfd.DualDiamPackedVesselObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilPyroRxObject = joint.shapes.pfd.pyroRxObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilWaterWashColumnObject = joint.shapes.pfd.WaterWashColumnObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilConveyorBeltISOObject = joint.shapes.pfd.ConveyorBeltISOObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilDrumObject = joint.shapes.pfd.DrumObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilConveyorRollerISOObject = joint.shapes.pfd.ConveyorRollerISOObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilConveyorGeneralISOObject = joint.shapes.pfd.TemplateObject.extend({
          defaults: joint.util.deepSupplement({
            type: 'pfd.ConveyorGeneralISOObject',
            size: { width: 10, height: 3 },
            ports: {
              items: [
                { group: 'in', args: { x: '0%', y: '50%' }, id: 'in_left_1', attrs: { portBody: { magnet: 'true' } } },
                { group: 'out', args: { x: '100%', y: '50%' }, id: 'out_right_4', attrs: { portBody: { magnet: 'true' } } },
              ]
            },
            attrs: {
              body: {
                refD: 'M 0 0 L 12 0 L 12 4 L 0 4 L 0 0',
                stroke: 'black',
                fill: 'transparent'
              },
              forbody: {
                refD: 'M 2 2 L 9 2 L 7.5 2.5 L 7.5 2 M 9 2 L 7.5 1.5 L 7.5 1.5 L 7.5 2 M 0 0 L 12 0 M 12 4 L 12 0 M 0 4 L 12 4 M 0 0 L 0 4',
                stroke: 'black',
                fill: 'black'
              },
              foreignObject: {
                refWidth: '1%',
                refHeight: '1%',
                ref: 'body',
                refX: -15,
                refY: 35
              }
            },
            markup: [{
              tagName: 'path',
              selector: 'body',
              className: 'elementBody'
            },
            {
              tagName: 'path',
              selector: 'forbody'
            }]
          }, joint.shapes.pfd.TemplateObject.prototype.defaults)
        });

        joint.shapes.pfd.StencilProcessGasAirCoolerObject = joint.shapes.pfd.ProcessGasAirCoolerObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilFlangedConnectionISOObject = joint.shapes.pfd.FlangedConnectionISOObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });

        joint.shapes.pfd.StencilHeatXPipesObject = joint.shapes.pfd.HeatXPipesObject.extend({
            markup: [{
                tagName: 'path',
                selector: 'body',
                className: 'elementBody'
              },
              {
                tagName: 'path',
                selector: 'forBody',
                className: 'elementforBody'
              },
              {
                tagName: 'path',
                selector: 'backBody',
                className: 'elementbackBody'
              }]
        });


        joint.shapes.bfd.StencilRectangleQuillObjectView= joint.shapes.bfd.RectangleQuillObjectView;
        joint.shapes.bfd.StencilTextBlockObjectView= joint.shapes.bfd.textBlockObjectView;
        joint.shapes.bfd.StencilTrapObjectView= joint.shapes.bfd.TrapObjectView;
        joint.shapes.pfd.StencilcrusherObjectView= joint.shapes.pfd.crusherObjectView;
        joint.shapes.pfd.StencilCircleObjectView= joint.shapes.pfd.CircleObjectView;
        joint.shapes.pfd.StencilPumpObjectView= joint.shapes.pfd.PumpObjectView;
        joint.shapes.pfd.StencilPumpObjectView= joint.shapes.pfd.PumpObjectView;
        joint.shapes.pfd.StencilFeedObjectView = joint.shapes.pfd.FeedObjectView;
        joint.shapes.pfd.StencilMixerSplitterObjectView = joint.shapes.pfd.MixerSplitterObjectView;
        joint.shapes.pfd.StencilVesselObjectView = joint.shapes.pfd.VesselObjectView;
        joint.shapes.pfd.StencilagitatedVesselObjectView = joint.shapes.pfd.agitatedVesselObjectView;
        joint.shapes.pfd.StencilElectroWinningHatchedObjectView = joint.shapes.pfd.ElectroWinningHatchedObjectView;
        joint.shapes.pfd.StencilElectroWinningObjectView = joint.shapes.pfd.ElectroWinningObjectView;
        joint.shapes.pfd.StencilElectrolyserStackObjectView = joint.shapes.pfd.ElectrolyserStackObjectView;
        joint.shapes.pfd.StencilHeatXObjectView = joint.shapes.pfd.HeatXObjectView;
        joint.shapes.pfd.StencilSettlerObjectView = joint.shapes.pfd.SettlerObjectView;
        joint.shapes.pfd.StencilFilter3ObjectView = joint.shapes.pfd.Filter3ObjectView;
        joint.shapes.pfd.StencilFilter4ObjectView = joint.shapes.pfd.Filter4ObjectView;
        joint.shapes.pfd.StencilFilter5ObjectView = joint.shapes.pfd.Filter3ObjectView;
        joint.shapes.pfd.StencilFilter6ObjectView = joint.shapes.pfd.Filter4ObjectView;
        joint.shapes.pfd.StencilmembraneObjectView = joint.shapes.pfd.Filter4ObjectView;
        joint.shapes.pfd.StencilOpenVesselObjectView = joint.shapes.pfd.membraneObjectView;
        joint.shapes.pfd.StencilTruckObjectView = joint.shapes.pfd.TruckObjectView;
        joint.shapes.pfd.StencilcomminutionObjectView= joint.shapes.pfd.comminutionObjectView;
        joint.shapes.pfd.StencilhaulageObjectView= joint.shapes.pfd.haulageObjectView;
        joint.shapes.pfd.StencilfactoryObjectView= joint.shapes.pfd.factoryObjectView;
        joint.shapes.pfd.StencilballMillObjectView= joint.shapes.pfd.ballMillObjectView;
        joint.shapes.pfd.StencilFlareObjectView = joint.shapes.pfd.FlareObjectView;
        joint.shapes.pfd.StencilHeatXMObjectView = joint.shapes.pfd.HeatXMObjectView;
        joint.shapes.pid.StencilTPObjectView = joint.shapes.pid.TPObjectView;
        joint.shapes.pid.StencilControllerObjectView = joint.shapes.pid.ControllerObjectView;
        joint.shapes.pfd.StencilSteamGenObjectView = joint.shapes.pfd.SteamGenObjectView;
        joint.shapes.pfd.StencilDualDiamVesselObjectView = joint.shapes.pfd.DualDiamVesselObjectView;
        joint.shapes.pfd.StencilFixedBedColumnObjectView = joint.shapes.pfd.FixedBedColumnObjectView;
        joint.shapes.pfd.StencilCompressorObjectView = joint.shapes.pfd.CompressorObjectView;
        joint.shapes.pfd.StencilVacuumPumpISOObjectView = joint.shapes.pfd.VacuumPumpISOObjectView;
        joint.shapes.pfd.StencilLiquidPumpISOObjectView = joint.shapes.pfd.LiquidPumpISOObjectView;
        joint.shapes.pfd.StencilTurbineISOObjectView = joint.shapes.pfd.TurbineISOObjectView;
        joint.shapes.pfd.StencilInsulatedConeObjectView = joint.shapes.pfd.InsulatedConeObjectView;
        joint.shapes.pfd.StencilCrusherConeTypeISOObjectView = joint.shapes.pfd.CrusherConeTypeISOObjectView;
        joint.shapes.pfd.StencilSolidSeparatorObjectView = joint.shapes.pfd.SolidSeparatorObjectView;
        joint.shapes.pfd.StencilHxEnFinnedTubeFanISOObjectView = joint.shapes.pfd.HxEnFinnedTubeFanISOObjectView;
        joint.shapes.pfd.StencilFurnaceObjectView = joint.shapes.pfd.FurnaceObjectView;
        joint.shapes.pfd.StencilFurnaceHXObjectView = joint.shapes.pfd.FurnaceHXObjectView;
        joint.shapes.pfd.StencilDualDiamPackedVesselObjectView = joint.shapes.pfd.DualDiamPackedVesselObjectView;
        joint.shapes.pfd.StencilPyroRxObjectView = joint.shapes.pfd.pyroRxObjectView;
        joint.shapes.pfd.StencilWaterWashColumnObjectView = joint.shapes.pfd.WaterWashColumnObjectView;
        joint.shapes.pfd.StencilConveyorBeltISOObjectView = joint.shapes.pfd.ConveyorBeltISOObjectView;
        joint.shapes.pfd.StencilDrumObjectView = joint.shapes.pfd.DrumObjectView;
        joint.shapes.pfd.StencilConveyorRollerISOObjectView = joint.shapes.pfd.ConveyorRollerISOObjectView;
        joint.shapes.pfd.StencilConveyorGeneralISOObjectView = joint.shapes.pfd.ConveyorGeneralISOObjectView;
        joint.shapes.pfd.StencilProcessGasAirCoolerObjectView = joint.shapes.pfd.ProcessGasAirCoolerObjectView;
        joint.shapes.pfd.StencilFlangedConnectionISOObjectView = joint.shapes.pfd.FlangedConnectionISOObjectView;
        joint.shapes.pfd.StencilHeatXPipesObjectView = joint.shapes.pfd.HeatXPipesObjectView;


        var stencil = this.stencil = new joint.ui.Stencil({
            paper: this.paper,
            scaleClones: true,
            width: 240,
            groups: {
                companyFlowShapes : { index: 1, label: 'Company Assets',closed: true},
                blockFlowShapes: { index: 2, label: 'Block Flow' },
                processFlowShapes: { index: 3, label: 'Process Flow' }
            },
            dropAnimation: true,
            groupsToggleButtons: false,
            search: {
                '*': ['type', 'attrs/label/text']
            },
            layout: {
                columnWidth: 80,
                columns: 2,
                rowHeight: 80,
                horizontalAlign: 'middle',
                columnGap: 20,
                rowGap: 5,
                marginX: 10,
                marginY: 0
            },  // Use default Grid Layout,
            snaplines: this.snaplines,
            paperOptions: function () {
                return {
                    background: { color: 'white' }
                }
            }
        });

        this.renderPlugin('.stencilContainer', stencil);

        // Filtered based on Index !!! IE: StencilCrusherConeTypeISOObject - ["Mining"] - index 0
        let dictLoadSectors = {
            companyFlowShapes: [
                ["Mining"],
                ['Manufacturing', 'Mining'],
                ["Mining"],
                ["Default"],
            ],
            blockFlowShapes: [
                ["Default"],
                ["Default"],
                ["Default"],
                ["Default"],
            ],
            processFlowShapes: [
                ["Default"],                             // StencilFeedObject
                ["Default", "Water"],                    // StencilPumpObject
                ["Default"],                             // StencilMixerSplitterObject
                ["Default"],                             // StencilVesselObject
                ["Default", "Water"],                    // StencilagitatedVesselObject
                ["Default", "Water"],                    // StencilElectroWinningHatchedObject
                ["Manufacturing", "Mining", "Gas"],      // StencilElectroWinningObject
                ["Water", "Mining", "Manufacturing"],    // StencilElectrolyserStackObject
                ["Water", "Mining", "Manufacturing"],    // StencilHeatXObject
                ["Water", "Mining", "Manufacturing"],    // StencilSettlerObject
                ["Water", "Mining", "Manufacturing"],    // StencilFilter3Object
                ["Default"],                             // StencilFilter4Object
                ["Transport"],                           // StencilFilter5Object
                ["Mining"],                              // StencilFilter6Object
                ["Mining"],                              // StencilmembraneObject
                ["Gas"],                                 // StencilOpenVesselObject
                ["Manufacturing", "Mining", "Gas"],      // StencilTruckObject
                ["Manufacturing", "Mining", "Gas"],      // StencilballMillObject
                ["Specialty"],                           // StencilcrusherObject
                ["Manufacturing", "Gas"],                // StencilFlareObject
                ["Gas"],                                 // StencilHeatXMObject
                ["Specialty"],                           // StencilSteamGenObject
                ["Water", "Manufacturing", "Gas", "Mining"], // StencilDualDiamVesselObject
                ["Gas"],                                 // StencilFixedBedColumnObject
                ["Specialty"],                           // StencilCompressorObject
                ["Water", "Manufacturing"],              // StencilVacuumPumpISOObject
                ["Manufacturing", "Mining", "Gas"],      // StencilLiquidPumpISOObject
                ["Manufacturing", "Gas"],                // StencilTurbineISOObject
                ["Manufacturing", "Mining", "Gas"],      // StencilInsulatedConeObject
                ["Specialty"],                           // StencilSolidSeparatorObject
                ["Mining", "Gas"],                       // StencilHxEnFinnedTubeFanISOObject
                ["Mining", "Gas"],                       // StencilFurnaceObject
                ["Mining", "Transport", "Manufacturing"], // StencilFurnaceHXObject
                ["Mining", "Transport", "Manufacturing"], // StencilDualDiamPackedVesselObject
                ["Mining", "Transport", "Manufacturing"], // StencilPyroRxObject
                ["Mining", "Transport", "Manufacturing"], // StencilWaterWashColumnObject
                ["Gas"],                                 // StencilConveyorBeltISOObject
                ["Mining", "Transport", "Manufacturing"], // StencilDrumObject
                ["Mining", "Transport", "Manufacturing"], // StencilConveyorRollerISOObject
                ["Mining", "Transport", "Manufacturing"], // StencilConveyorGeneralISOObject
                ["Gas"],                                 // StencilProcessGasAirCoolerObject
                ["PID"],                                 // StencilFlangedConnectionISOObject
                ["Mining", "Gas"]  
            ]
        }


        let dictToLoad = {
            companyFlowShapes: [
                new joint.shapes.pfd.StencilCrusherConeTypeISOObject(),
                new joint.shapes.pfd.StencilfactoryObject(),
                new joint.shapes.pfd.StencilcomminutionObject(),
                new joint.shapes.pfd.StencilhaulageObject()
            ],
            blockFlowShapes: [
                new joint.shapes.bfd.StencilRectangleQuillObject(),
                new joint.shapes.bfd.StencilTextBlockObject(),
                new joint.shapes.bfd.StencilTrapObject(),
                new joint.shapes.pfd.StencilCircleObject(),
            ],
            processFlowShapes: [
                new joint.shapes.pfd.StencilFeedObject(),
                new joint.shapes.pfd.StencilPumpObject(),
                new joint.shapes.pipework.StencilMixerSplitterObject(),
                // new joint.shapes.pfd.StencilValveObject(), // commented out as in your list
                new joint.shapes.pfd.StencilVesselObject(),
                new joint.shapes.pfd.StencilagitatedVesselObject(),
                new joint.shapes.pfd.StencilElectroWinningHatchedObject(),
                new joint.shapes.pfd.StencilElectroWinningObject(),
                new joint.shapes.pfd.StencilElectrolyserStackObject(),
                new joint.shapes.pfd.StencilHeatXObject(),
                new joint.shapes.pfd.StencilSettlerObject(),
                new joint.shapes.pfd.StencilFilter3Object(),
                new joint.shapes.pfd.StencilFilter4Object(),
                new joint.shapes.pfd.StencilFilter5Object(),
                new joint.shapes.pfd.StencilFilter6Object(),
                new joint.shapes.pfd.StencilmembraneObject(),
                new joint.shapes.pfd.StencilOpenVesselObject(),
                new joint.shapes.pfd.StencilTruckObject(),
                new joint.shapes.pfd.StencilballMillObject(),
                new joint.shapes.pfd.StencilcrusherObject(),
                new joint.shapes.pfd.StencilFlareObject(),
                new joint.shapes.pfd.StencilHeatXMObject(),
                //new joint.shapes.pid.StencilTPObject(),
                //new joint.shapes.pid.StencilControllerObject(),
                new joint.shapes.pfd.StencilSteamGenObject(),
                new joint.shapes.pfd.StencilDualDiamVesselObject(),
                new joint.shapes.pfd.StencilFixedBedColumnObject(),
                new joint.shapes.pfd.StencilCompressorObject(),
                new joint.shapes.pfd.StencilVacuumPumpISOObject(),
                new joint.shapes.pfd.StencilLiquidPumpISOObject(),
                new joint.shapes.pfd.StencilTurbineISOObject(),
                new joint.shapes.pfd.StencilInsulatedConeObject(),
                // new joint.shapes.pfd.StencilCrusherConeTypeISOObject(),
                new joint.shapes.pfd.StencilSolidSeparatorObject(),
                new joint.shapes.pfd.StencilHxEnFinnedTubeFanISOObject(),
                new joint.shapes.pfd.StencilFurnaceObject(),
                new joint.shapes.pfd.StencilFurnaceHXObject(),
                new joint.shapes.pfd.StencilDualDiamPackedVesselObject(),
                new joint.shapes.pfd.StencilPyroRxObject(),
                new joint.shapes.pfd.StencilWaterWashColumnObject(),
                new joint.shapes.pfd.StencilConveyorBeltISOObject(),
                new joint.shapes.pfd.StencilDrumObject(),
                new joint.shapes.pfd.StencilConveyorRollerISOObject(),
                new joint.shapes.pfd.StencilConveyorGeneralISOObject(),
                new joint.shapes.pfd.StencilProcessGasAirCoolerObject(),
                new joint.shapes.pfd.StencilFlangedConnectionISOObject(),
                new joint.shapes.pfd.StencilHeatXPipesObject()
            ]
        }

        // filtered dictToLoad based on index
        dictToLoad.companyFlowShapes = dictToLoad.companyFlowShapes.filter((item, index) => {
            if(dictLoadSectors.companyFlowShapes[index].includes("Default")) {
                return true
            }
            for(let sector of this.orgSectors) {
                if(dictLoadSectors.companyFlowShapes[index].includes(sector)) {
                    return true
                }
            }
        })

        dictToLoad.blockFlowShapes = dictToLoad.blockFlowShapes.filter((item, index) => {
            if(dictLoadSectors.blockFlowShapes[index].includes("Default")) {
                return true
            }
            for(let sector of this.orgSectors) {
                if(dictLoadSectors.blockFlowShapes[index].includes(sector)) {
                    return true
                }
            }
        })

        dictToLoad.processFlowShapes = dictToLoad.processFlowShapes.filter((item, index) => {
            if(dictLoadSectors.processFlowShapes[index].includes("Default")) {
                return true
            }
            for(let sector of this.orgSectors) {
                if(dictLoadSectors.processFlowShapes[index].includes(sector)) {
                    return true
                }
            }
        })

        stencil.load(dictToLoad);

        function createTooltip() {
            const tooltip = document.createElement('div');
            tooltip.style.position = 'absolute';
            tooltip.style.padding = '5px';
            tooltip.style.background = 'rgba(0, 0, 0, 0.7)';
            tooltip.style.color = 'white';
            tooltip.style.borderRadius = '5px';
            tooltip.style.visibility = 'hidden';
            tooltip.style.fontSize = '14px';
            document.body.appendChild(tooltip);
            return tooltip;
        }
        
        const tooltip = createTooltip();
        // Function to update tooltip content and show it
        function showTooltip(evt, text) {
            // Remove "pfd.", "bfd.", "pipework.", "pid.", or "Object" at the end if present
            const tooltipText = text.replace(/\.(pfd|bfd|pipework|pid)$|Object$/g, '');
            tooltip.innerText = tooltipText;
            tooltip.style.visibility = 'visible';
            tooltip.style.top = `${evt.clientY + 10}px`;
            tooltip.style.left = `${evt.clientX + 10}px`;
        }
        // Function to hide the tooltip
        function hideTooltip() {
            tooltip.style.visibility = 'hidden';
        }
        
        // Attach event listeners to each shape in each category
        Object.keys(dictToLoad).forEach(category => {
            dictToLoad[category].forEach(shape => {
                // Assuming each shape has a method to get its view and name/label is stored in shape.attributes.attrs.label.text
        
                let contentGroups = this.stencil.el.getElementsByClassName('content');
        
                Array.from(contentGroups).forEach(group => {
                    const elementsWithModelId = group.querySelectorAll('[model-id]');
        
                    // Attach event listeners to each element with 'model-id'
                    elementsWithModelId.forEach(element => {
                        const modelId = element.getAttribute('data-type');
                        // Assuming modelId is what you want to show in the tooltip
                        // If not, you might need to find a way to map modelId to the corresponding name or description
        
                        // Update modelId to remove "pfd.", "bfd.", "pipework.", "pid.", or "Object" at the end if present
                        const tooltipContent = modelId.replace(/^(pfd\.|bfd\.|pipework\.|pid\.|Object$)/, '');
        
                        element.addEventListener('mouseenter', (evt) => showTooltip(evt, tooltipContent));
                        element.addEventListener('mouseleave', hideTooltip);
                    });
                })
            });
        });        
        
        stencil.on('element:drop', (cell) => {
            var position = cell.model.attributes.position
            var size = cell.model.attributes.size
            const typePath = cell.model.attributes.type.split('.');
            let currentObject = joint.shapes;

            for (let part of typePath) {
                currentObject = currentObject[part];
            }

            const object = new currentObject({
                position: position,
                size: size
            })
            this.graph.addCell(object);
            this.graph.removeCells([cell.model])
            graphAdd(object)

        })

        stencil.on('element:dragstart', (cloneView, evt, dropArea, validDropTarget) => {
            if (cloneView.model.attributes.type == 'pfd.PumpObject') {
                cloneView.model.resize(40, 40)

            }
            if (cloneView.model.attributes.type == 'pipework.MixerSplitterObject') {
                cloneView.model.resize(30, 30)


            }
            if (cloneView.model.attributes.type == 'pipework.ValveObject') {
                cloneView.model.resize(30, 19)


            }
            if (cloneView.model.attributes.type == 'bfd.RectangleQuillObject') {
                cloneView.model.resize(90, 60)

            }
            if (cloneView.model.attributes.type == 'bfd.textBlockObject') {
                cloneView.model.resize(105, 70)

            }
            if (cloneView.model.attributes.type == 'pfd.haulageObject') {
                cloneView.model.resize(187.5, 150)

            }
            if (cloneView.model.attributes.type == 'pfd.comminutionObject') {
                cloneView.model.resize(187.5, 150)

            }
            if (cloneView.model.attributes.type == 'pfd.factoryObject') {
                cloneView.model.resize(156, 150)

            }
            if (cloneView.model.attributes.type == 'pfd.CrusherConeTypeISOObject') {
                cloneView.model.resize(150, 75)

            }
            if (cloneView.model.attributes.type == 'pid.TPObject') {
                cloneView.model.resize(30, 30)

            }
            if (cloneView.model.attributes.type == 'pid.ControllerObject') {
                cloneView.model.resize(30, 30)

            }
            if (cloneView.model.attributes.type == 'pfd.HeatXObject') {
                cloneView.model.resize(40, 40)

            }
            if (cloneView.model.attributes.type == 'pfd.HeatXMObject') {
                cloneView.model.resize(42.5, 40)

            }
            if (cloneView.model.attributes.type == 'pfd.TruckObject') {
                cloneView.model.resize(90, 60)

            }
            if (cloneView.model.attributes.type == 'pfd.VesselObject') {
                cloneView.model.resize(60, 90)

            }
            if (cloneView.model.attributes.type == 'pfd.agitatedVesselObject') {
                cloneView.model.resize(60, 90)

            }
            if (cloneView.model.attributes.type == 'pfd.OpenVesselObject') {
                cloneView.model.resize(90, 60)

            }
            if (cloneView.model.attributes.type == 'pfd.FlareObject') {
                cloneView.model.resize(60, 90)

            }
            if (cloneView.model.attributes.type == 'pfd.DualDiamVesselObject') {
                cloneView.model.resize(60, 120)

            }
            if (cloneView.model.attributes.type == 'pfd.FixedBedColumnObject') {
                cloneView.model.resize(60, 120)

            }
            if (cloneView.model.attributes.type == 'pfd.VacuumPumpISOObject') {
                cloneView.model.resize(40, 40)

            }
            if (cloneView.model.attributes.type == 'pfd.LiquidPumpISOObject') {
                cloneView.model.resize(40, 40)

            }
            if (cloneView.model.attributes.type == 'pfd.TurbineISOObject') {
                cloneView.model.resize(80, 80)

            }
            if (cloneView.model.attributes.type == 'pfd.FurnaceObject') {
                cloneView.model.resize(65, 90)

            }
            if (cloneView.model.attributes.type == 'pfd.FurnaceHXObject') {
                cloneView.model.resize(75, 90)

            }
            if (cloneView.model.attributes.type == 'pfd.DualDiamPackedVesselObject') {
                cloneView.model.resize(60, 120)

            }
            if (cloneView.model.attributes.type == 'pfd.pyroRxObject') {
                cloneView.model.resize(60, 120)

            }
            if (cloneView.model.attributes.type == 'pfd.WaterWashColumnObject') {
                cloneView.model.resize(60, 90)

            }
            if (cloneView.model.attributes.type == 'pfd.ConveyorBeltISOObject') {
                cloneView.model.resize(100, 20)

            }
            if (cloneView.model.attributes.type == 'pfd.ConveyorGeneralISOObject') {
                cloneView.model.resize(100, 30)

            }
            if (cloneView.model.attributes.type == 'pfd.ConveyorRollerISOObject') {
                cloneView.model.resize(100, 15)

            }
            if (cloneView.model.attributes.type == 'pfd.DrumObject') {
                cloneView.model.resize(100, 30)

            }
            if (cloneView.model.attributes.type == 'pfd.ProcessGasAirCoolerObject') {
                cloneView.model.resize(100, 30)

            }
            if (cloneView.model.attributes.type == 'pfd.electroWinningObject') {
                cloneView.model.resize(100, 100);
                cloneView.model.attr('anodeInput/value', 'Anode')
                cloneView.model.attr('cathodeInput/value', 'Cathode')
            }
            if (cloneView.model.attributes.type == 'pfd.electroWinningHatchedObject') {
                cloneView.model.resize(100, 100)
                cloneView.model.attr('anodeInput/value', 'Anode')
                cloneView.model.attr('cathodeInput/value', 'Cathode')
                cloneView.model.attr('EMInput/value', 'EM')
            }
            if (cloneView.model.attributes.type == 'pfd.electrolyserStackObject') {
                cloneView.model.resize(100, 100)
                cloneView.model.attr('anodeInput/value', 'Anode')
                cloneView.model.attr('cathodeInput/value', 'Cathode')
                cloneView.model.attr('EMInput/value', 'EM')
            }
        })

        stencil.on('element:drag', (cloneView, evt, dropArea, validDropTarget) => {
            if (cloneView.model.attributes.type == 'pipework.MixerSplitterObject') {
                cloneView.model.position(15, 15)

            }
            if (cloneView.model.attributes.type == 'pfd.PumpObject') {
                cloneView.model.position(10, 10)

            }
            if (cloneView.model.attributes.type == 'bfd.RectangleQuillObject') {
                cloneView.model.position(-15, -12)

            }
            if (cloneView.model.attributes.type == 'bfd.textBlockObject') {
                cloneView.model.position(-22.5, -15)

            }
            if (cloneView.model.attributes.type == 'pfd.HeatXObject') {
                cloneView.model.position(15, 15)

            }
            if (cloneView.model.attributes.type == 'pfd.HeatXMObject') {
                cloneView.model.position(12, 12)

            }
            if (cloneView.model.attributes.type == 'pid.TPObject') {
                cloneView.model.position(15, 15)

            }
            if (cloneView.model.attributes.type == 'pid.ControllerObject') {
                cloneView.model.position(15, 15)

            }
            if (cloneView.model.attributes.type == 'pfd.TruckObject') {
                cloneView.model.position(-15, -15)

            }
            if (cloneView.model.attributes.type == 'pfd.VesselObject') {
                cloneView.model.position(-15, -15)

            }
            if (cloneView.model.attributes.type == 'pfd.OpenVesselObject') {
                cloneView.model.position(-15, -15)

            }
            if (cloneView.model.attributes.type == 'pfd.FlareObject') {
                cloneView.model.position(-10, -15)

            }
            if (cloneView.model.attributes.type == 'pfd.DualDiamVesselObject') {
                cloneView.model.position(-15, -35)

            }
            if (cloneView.model.attributes.type == 'pfd.FixedBedColumnObject') {
                cloneView.model.position(-15, -35)

            }
            if (cloneView.model.attributes.type == 'pfd.VacuumPumpISOObject') {
                cloneView.model.position(15, 15)

            }
            if (cloneView.model.attributes.type == 'pfd.LiquidPumpISOObject') {
                cloneView.model.position(15, 15)

            }
            if (cloneView.model.attributes.type == 'pfd.TurbineISOObject') {
                cloneView.model.position(-12, -12)

            }
            if (cloneView.model.attributes.type == 'pfd.FurnaceObject') {
                cloneView.model.position(-15, -15)

            }
            if (cloneView.model.attributes.type == 'pfd.FurnaceHXObject') {
                cloneView.model.position(-15, -15)

            }
            if (cloneView.model.attributes.type == 'pfd.DualDiamPackedVesselObject') {
                cloneView.model.position(-15, -35)

            }
            if (cloneView.model.attributes.type == 'pfd.pyroRxObject') {
                cloneView.model.position(-10, -35)

            }
            if (cloneView.model.attributes.type == 'pfd.WaterWashColumnObject') {
                cloneView.model.position(-15, -15)

            }
            if (cloneView.model.attributes.type == 'pfd.ConveyorBeltISOObject') {
                cloneView.model.position(-20, -5)

            }
            if (cloneView.model.attributes.type == 'pfd.ConveyorRollerISOObject') {
                cloneView.model.position(-20, -5)

            }
            if (cloneView.model.attributes.type == 'pfd.ConveyorGeneralISOObject') {
                cloneView.model.position(-20, -5)

            }
            if (cloneView.model.attributes.type == 'pfd.DrumObject') {
                cloneView.model.position(-20, -5)

            }
            if (cloneView.model.attributes.type == 'pfd.ProcessGasAirCoolerObject') {
                cloneView.model.position(-20, -5)

            }
        })

        var graph = this.graph
        var paper = this.paper

        graph.on('change add remove', () => {
          var diagramJsonString = JSON.stringify(graph.toJSON());
          //console.log('Diagram JSON', diagramJsonString);
      });
      graph.on('remove', (cell) => {
          if (cell.isLink()) {
              this.stream_Count = 1
          }
      })
      graph.on('change', (cell) => {
          // TextOverlayManager handles text editing - no embedded Quill needed
      })
      graph.on('change:position', (element, position) => {
        this.hasUpdated(true)
          var connected_Links = graph.getConnectedLinks(element);
          for (let i = 0; i < connected_Links.length; i++) {
              let link_Vertices = connected_Links[i].vertices()
              for (let z = 0; z < link_Vertices.length; z++) {
                  connected_Links[i].removeVertex(-1)
              }


          }
      });


      paper.on('element:pointerup', (cellView, evt, x, y) => {
          let element = cellView.model
          var connected_Links = graph.getConnectedLinks(element);
          for (let i = 0; i < connected_Links.length; i++) {
              if (connected_Links[i].vertices() == []) {

                  let linkView = paper.findViewByModel(connected_Links[i])
                  let link_Svg_String = linkView.getSerializedConnection();
                  link_Svg_String = link_Svg_String.replace('M ', '');
                  let source_Point = linkView.model.getSourcePoint();
                  let target_Point = linkView.model.getTargetPoint();
                  link_Path_Array = link_Svg_String.split(" L ");
                  let link_Coordinates = [];
                  for (let i = 0; i < link_Path_Array.length; i++) {
                      link_Coordinates.push(link_Path_Array[i].split(" "))
                  }
                  for (let i = 0; i < link_Coordinates.length; i++) {
                      let vertex = { x: link_Coordinates[i][0], y: link_Coordinates[i][1] }
                      if (!(((Math.abs(source_Point.x - vertex.x) < 5) && (Math.abs(source_Point.y - vertex.y) < 5)) || ((Math.abs(target_Point.x - vertex.x) < 5) && (Math.abs(target_Point.y - vertex.y) < 5)))) {
                          linkView.addVertex(parseInt(vertex.x, 10), parseInt(vertex.y, 10))
                      }
                  }
                  linkView.removeRedundantLinearVertices()
              }
          }

      })
      let graphAdd = this.graphAdd = (cell) => {
        this.hasUpdated(true)
          if (cell.isLink() && (cell.attributes.type != 'mix.Connector')) {
              cell.prop('line_Style', 'normal')
              let linkView = paper.findViewByModel(cell)
              linkView.model.label(0, {
                  markup: [{
                      tagName: 'path',
                      selector: 'body'
                  }, {
                      tagName: 'foreignObject',
                      selector: 'foreignObject',
                      attributes: {
                          'overflow': 'visible',
                      },
                      children: [{
                          tagName: 'input',
                          className: 'joint-link-label-input-divs',
                          selector: 'labelInputDiv',
                          namespaceURI: 'http://www.w3.org/1999/xhtml',
                          attributes: {
                              //'type': 'number',
                              'name': 'labelInputDiv',
                              'type': 'number',
                              'id': linkView.model.id + 'labelInputDiv'
                          }
                      }]
                  }],

                  attrs: {
                      body: {
                          refD: 'M 0 0 L 0 18 L 26 18 L 26 0 Z',
                          stroke: 'none',
                          fill: 'transparent',
                          yAlignment: 'middle',
                          // refY: 12,
                          refX: 0,
                          xAlignment: 'middle',
                      },
                      foreignObject: {
                          refWidth: '100%',
                          refHeight: '100%',
                          ref: 'body',
                          //yAlignment: 'middle',
                          refX: 0,
                          refY: 1.5,
                          //xAlignment: 'middle',
                          labelInputDiv: {
                              value: {
                                  set: function (text, _, node) {
                                      if ('value' in node) {
                                          node.value = text;
                                      }
                                  }
                              }
                          }
                      }
                  },
                  position: {
                      distance: 0.40
                  }
              });
              let try_Again = () => {
                  this.stream_Count += 1
                  if (!(this.stream_Number_Verification(this.stream_Count, linkView.model.id))) {
                      try_Again()
                  }
              }
              if (!(this.stream_Number_Verification(this.stream_Count, linkView.model.id))) {
                  try_Again()
              }

              linkView.model.label(0, { attrs: { 'labelInputDiv': { value: this.stream_Count } } });
              linkView.model.prop('CustomName', this.stream_Count)
              // Add an event to changing the input text
              this.stream_Count = this.stream_Count + 1;
              //stream_Count_Input_Div.value = stream_Count;

              cell.connector({ name: 'jumpover', args: { jump: 'gap', size: 4 } });
          }
          else if ((cell.attributes.type.search('pfd') != -1) || (cell.attributes.type.search('bfd') != -1)) {
              // All shapes need to start as yes - TextOverlayManager will handle the editor
              cell.prop('isUnit', 'yes');
          }

          // QUILL POSITIONING WHEN DRAGGED ON / GENERAL DRAG ON CHANGES GTB
          if (cell.attributes.type == 'pfd.PumpObject') {
              cell.prop('unitType', 'Pump');
              cell.attr('shapename/style/top', '0px')
              cell.attr('shapename/style/left', '-12px')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.FeedObject') {

              cell.attr('shapename/style/top', '-10px')
              cell.attr('shapename/style/left', '-18px')
              cell.attr('shapename/style/width', '120px')
              cell.attr('shapename/style/height', '20px')

              cell.prop('unitType', "Feed")
          }
          else if (cell.attributes.type == 'pid.TPObject') {
              cell.prop('unitType', 'Sensor');
          }
          else if (cell.attributes.type == 'pid.ControllerObject') {
              cell.prop('unitType', 'Controller');
          }
          else if (cell.attributes.type == 'bfd.RectangleQuillObject') {
              cell.prop('unitType', 'Textbox');
              cell.attr('shapename/style/top', '')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '80px')
              cell.attr('shapename/style/height', '40px')
          }
          else if (cell.attributes.type == 'bfd.textBlockObject') {
              cell.prop('unitType', 'Textbox');
              cell.attr('body/stroke', 'transparent')
              cell.attr('backBody/stroke', 'transparent')
              cell.attr('forBody/stroke', 'transparent')
              cell.attr('forBody/fill', 'transparent')
              cell.attr('shapename/style/top', '')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '80px')
              cell.attr('shapename/style/height', '40px')
              //console.log(getElementById(cell.prop('unitType')))
              //document.getElementById(cell.attr('body').classList.remove)
              //console.log(document.getElementById(cell.attr('body').classList))
          }
          else if (cell.attributes.type == 'pfd.crusherObject') {
            cell.prop('unitType', 'crusher');
            cell.attr('shapename/style/top', '-20px')
            cell.attr('shapename/style/left', '')
            cell.attr('shapename/style/width', '90px')
            cell.attr('shapename/style/height', '40px')
          }
          else if (cell.attributes.type == 'pfd.TruckObject') {
              cell.prop('unitType', 'Truck');
              cell.attr('shapename/style/top', '-20px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '90px')
              cell.attr('shapename/style/height', '40px')
          }
          else if (cell.attributes.type == 'pfd.factoryObject') {
            cell.prop('unitType', 'factory');
            cell.attr('shapename/style/top', '-20px')
            cell.attr('shapename/style/left', '')
            cell.attr('shapename/style/width', '90px')
            cell.attr('shapename/style/height', '40px')
          }
          else if (cell.attributes.type == 'pfd.comminutionObject') {
            cell.prop('unitType', 'comminution');
            cell.attr('shapename/style/top', '-20px')
            cell.attr('shapename/style/left', '')
            cell.attr('shapename/style/width', '90px')
            cell.attr('shapename/style/height', '40px')
          }
          else if (cell.attributes.type == 'pfd.haulageObject') {
            cell.prop('unitType', 'haulage');
            cell.attr('shapename/style/top', '-20px')
            cell.attr('shapename/style/left', '')
            cell.attr('shapename/style/width', '90px')
            cell.attr('shapename/style/height', '40px')
          }
          else if (cell.attributes.type == 'pfd.ballMillObject') {
            cell.prop('unitType', 'ballMill');
            cell.attr('shapename/style/top', '-20px')
            cell.attr('shapename/style/left', '')
            cell.attr('shapename/style/width', '90px')
            cell.attr('shapename/style/height', '40px')
          }
          else if (cell.attributes.type == 'pfd.FilterObject') {
              cell.prop('unitType', 'Filter');
              cell.attr('shapename/style/top', '5px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.Filter2Object') {
              cell.prop('unitType', 'Filter');
              cell.attr('shapename/style/top', '8px')
              cell.attr('shapename/style/left', '-2px')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.Filter3Object') {
              cell.prop('unitType', 'Filter');
              cell.attr('shapename/style/top', '8px')
              cell.attr('shapename/style/left', '-2px')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.Filter4Object') {
              cell.prop('unitType', 'Filter');
              cell.attr('shapename/style/top', '8px')
              cell.attr('shapename/style/left', '-2px')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.Filter5Object') {
            cell.prop('unitType', 'Filter');
            cell.attr('shapename/style/top', '8px')
            cell.attr('shapename/style/left', '-2px')
            cell.attr('shapename/style/width', '60px')
            cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.Filter6Object') {
            cell.prop('unitType', 'Filter');
            cell.attr('shapename/style/top', '8px')
            cell.attr('shapename/style/left', '-2px')
            cell.attr('shapename/style/width', '60px')
            cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.membraneObject') {
            cell.prop('unitType', 'Filter');
            cell.attr('shapename/style/top', '8px')
            cell.attr('shapename/style/left', '-2px')
            cell.attr('shapename/style/width', '60px')
            cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.VesselObject') {
              cell.prop('unitType', 'Vessel');
              cell.attr('shapename/style/top', '')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '65px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.agitatedVesselObject') {
            cell.prop('unitType', 'Vessel');
            cell.attr('shapename/style/top', '')
            cell.attr('shapename/style/left', '')
            cell.attr('shapename/style/width', '65px')
            cell.attr('shapename/style/height', '30px')
        }
          else if (cell.attributes.type == 'pfd.WaterWashColumnObject') {
              cell.prop('unitType', 'Vessel');
              cell.attr('shapename/style/top', '90px')
              cell.attr('shapename/style/left', '-5px')
              cell.attr('shapename/style/width', '65px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.HeatXObject') {
              cell.prop('unitType', 'HeatExchanger');
              cell.attr('shapename/style/top', '')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.HeatXMObject') {
              cell.prop('unitType', 'HeatExchanger');
              cell.attr('shapename/style/top', '-15px')
              cell.attr('shapename/style/left', '-15px')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.SettlerObject') {
              cell.prop('unitType', 'Settler');
              cell.attr('shapename/style/top', '-15px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.OpenVesselObject') {
              cell.prop('unitType', 'Vessel');
              cell.attr('shapename/style/top', '')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '90px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.FlareObject') {
              cell.prop('unitType', 'Flare');
              cell.attr('shapename/style/top', '40px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.SteamGenObject') {
              cell.prop('unitType', 'SteamGenerator');
              cell.attr('shapename/style/top', '5px')
              cell.attr('shapename/style/left', '-5px')
              cell.attr('shapename/style/width', '65px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.DualDiamVesselObject') {
              cell.prop('unitType', 'SteamGenerator');
              cell.attr('shapename/style/top', '65px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pfd.FixedBedColumnObject') {
              cell.prop('unitType', 'FixedBedColumn');
              cell.attr('shapename/style/top', '65px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pfd.CompressorObject') {
              cell.prop('unitType', 'Compressor');
              cell.attr('shapename/style/top', '20px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '65px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pfd.VacuumPumpISOObject') {
              cell.prop('unitType', 'Pump');
              cell.attr('shapename/style/top', '')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.LiquidPumpISOObject') {
              cell.prop('unitType', 'Pump');
              cell.attr('shapename/style/top', '')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.TurbineISOObject') {
              cell.prop('unitType', 'Turbine');
              cell.attr('shapename/style/top', '20px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '65px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pfd.InsulatedConeObject') {
              cell.prop('unitType', 'Settler');
              cell.attr('shapename/style/top', '-15px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.CrusherConeTypeISOObject') {
              cell.prop('unitType', 'Crusher');
              cell.attr('shapename/style/top', '-10px')
              cell.attr('shapename/style/left', '-5px')
              cell.attr('shapename/style/width', '70px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'bfd.TrapObject') {
              cell.prop('unitType', 'Trapezoid');
              cell.attr('shapename/style/top', '20px')
              cell.attr('shapename/style/left', '-5px')
              cell.attr('shapename/style/width', '70px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.SolidSeparatorObject') {
              cell.prop('unitType', 'TrapezoidSolidSeparator');
              cell.attr('shapename/style/top', '-15px')
              cell.attr('shapename/style/left', '-5px')
              cell.attr('shapename/style/width', '70px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.HxEnFinnedTubeFanISOObject') {
              cell.prop('unitType', 'HeatExchanger');
              cell.attr('shapename/style/top', '80px')
              cell.attr('shapename/style/left', '0px')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.FurnaceObject') {
              cell.prop('unitType', 'Furnace');
              cell.attr('shapename/style/top', '30px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '65px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.FurnaceHXObject') {
              cell.prop('unitType', 'FurnaceHeatExchanger');
              cell.attr('shapename/style/top', '30px')
              cell.attr('shapename/style/left', '10px')
              cell.attr('shapename/style/width', '65px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.DualDiamPackedVesselObject') {
              cell.prop('unitType', 'Steam Generator');
              cell.attr('shapename/style/top', '65px')
              cell.attr('shapename/style/left', '')
              cell.attr('shapename/style/width', '60px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pfd.pyroRxObject') {
              cell.prop('unitType', 'SteamGenerator');
              cell.attr('shapename/style/top', '65px')
              cell.attr('shapename/style/left', '5px')
              cell.attr('shapename/style/width', '55px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pfd.DrumObject') {
              cell.prop('unitType', 'Drum');
              cell.attr('shapename/style/top', '-1px')
              cell.attr('shapename/style/left', '25px')
              cell.attr('shapename/style/width', '80px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pfd.ConveyorBeltISOObject') {
              cell.prop('unitType', 'FeedConveyor');
              cell.attr('shapename/style/top', '-11.5px')
              cell.attr('shapename/style/left', '25px')
              cell.attr('shapename/style/width', '80px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pfd.ConveyorGeneralISOObject') {
              cell.prop('unitType', 'FeedConveyor');
              cell.attr('shapename/style/top', '')
              cell.attr('shapename/style/left', '25px')
              cell.attr('shapename/style/width', '80px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pfd.ProcessGasAirCoolerObject') {
              cell.prop('unitType', 'HeatExchanger');
              cell.attr('shapename/style/top', '')
              cell.attr('shapename/style/left', '20px')
              cell.attr('shapename/style/width', '80px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pfd.ConveyorRollerISOObject') {
              cell.prop('unitType', 'FeedConveyor');
              cell.attr('shapename/style/top', '-13px')
              cell.attr('shapename/style/left', '25px')
              cell.attr('shapename/style/width', '80px')
              cell.attr('shapename/style/height', '20px')
          }
          else if (cell.attributes.type == 'pipework.MixerSplitterObject') {
              cell.prop('unitType', 'pipework');
              cell.prop('isUnit', 'yes');

          }
          else if (cell.attributes.type == 'pipework.ValveObject') {
              cell.prop('unitType', 'valve');

          }
          else if (cell.attributes.type == 'pfd.electroWinningObject') {
              cell.prop('unitType', 'Electrowinning');
              cell.attr('shapename/style/top', '20%')
              cell.attr('shapename/style/left', '3.5%')
              cell.attr('shapename/style/width', '100px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.electroWinningHatchedObject') {
              cell.prop('unitType', 'Electrowinning');
              cell.attr('shapename/style/top', '-20%')
              cell.attr('shapename/style/left', '3.5%')
              cell.attr('shapename/style/width', '100px')
              cell.attr('shapename/style/height', '30px')
          }
          else if (cell.attributes.type == 'pfd.electrolyserStackObject') {
              cell.prop('unitType', 'Electrowinning');
              cell.attr('shapename/style/top', '-20%')
              cell.attr('shapename/style/left', '3.5%')
              cell.attr('shapename/style/width', '100px')
              cell.attr('shapename/style/height', '30px')
          }
          // ADD THIS AT THE END OF THE graphAdd FUNCTION
            // After all properties have been set, process the unit for numbering
            if (this.unitNumberingService) {
                // Check if this is a unit that should be numbered
                if (!cell.isLink() && 
                    cell.prop('isUnit') === 'yes' && 
                    cell.prop('unitType') && 
                    cell.prop('unitType') !== 'Feed' && 
                    cell.prop('unitType') !== 'Product' && 
                    cell.prop('unitType') !== 'pipework') {
                    
                    console.log('Direct unit numbering: Processing unit', cell.id);
                    this.unitNumberingService.assignUnitNumber(cell);
                }
            }
      }


      //delete
      paper.on('link:snap:disconnect', (linkView, evt, elementViewDisconnected, magnet, arrowhead) => {
        this.hasUpdated(true)
                // Handle pipework arrows and lines
            if (elementViewDisconnected.model.prop('unitType') === 'pipework') {
                // Track remaining connections to determine if lines should be hidden
                let these_Arms_Remain = [];
                let inbound_Links = graph.getConnectedLinks(elementViewDisconnected.model, { inbound: true });
                let outbound_Links = graph.getConnectedLinks(elementViewDisconnected.model, { outbound: true });
                
                // Collect all remaining connected ports
                for (let i = 0; i < inbound_Links.length; i++) {
                    these_Arms_Remain.push(inbound_Links[i].target().port)
                }
                for (let i = 0; i < outbound_Links.length; i++) {
                    these_Arms_Remain.push(outbound_Links[i].source().port)
                }

                // Handle top ports
                if (magnet.getAttribute('port') === 'in_top_1') {
                    elementViewDisconnected.model.attr('toplinearrow/fill', 'none')
                    if (!(these_Arms_Remain.includes('in_top_1') || these_Arms_Remain.includes('out_top_1'))) {
                        elementViewDisconnected.model.attr('topline/stroke', 'none')
                    }
                }

                // Handle bottom ports
                if (magnet.getAttribute('port') === 'in_bottom_1') {
                    elementViewDisconnected.model.attr('bottomlinearrow/fill', 'none')
                    if (!(these_Arms_Remain.includes('in_bottom_1') || these_Arms_Remain.includes('out_bottom_1'))) {
                        elementViewDisconnected.model.attr('bottomline/stroke', 'none')
                    }
                }

                // Handle right ports
                if (magnet.getAttribute('port') === 'in_right_1') {
                    elementViewDisconnected.model.attr('rightlinearrow/fill', 'none')
                    if (!(these_Arms_Remain.includes('in_right_1') || these_Arms_Remain.includes('out_right_1'))) {
                        elementViewDisconnected.model.attr('rightline/stroke', 'none')
                    }
                }

                // Handle left ports
                if (magnet.getAttribute('port') === 'in_left_1') {
                    elementViewDisconnected.model.attr('leftlinearrow/fill', 'none')
                    if (!(these_Arms_Remain.includes('in_left_1') || these_Arms_Remain.includes('out_left_1'))) {
                        elementViewDisconnected.model.attr('leftline/stroke', 'none')
                    }
                }

                // If no connections remain, show crosshairs and reset body
                if (these_Arms_Remain.length === 0) {
                    elementViewDisconnected.model.attr('crosshairs/stroke', 'black')
                    elementViewDisconnected.model.attr('body/stroke', 'black')
                    elementViewDisconnected.model.attr('body/fill', 'white')
                }
            }

            // Handle the disconnected link itself
            linkView.model.attr('line/targetMarker/d', 'M 10 -5 0 0 10 5 z')
            linkView.model.attr('line/stroke-dasharray', '0,0')
                

          linkView.model.label(0, {
              markup: [{
                  tagName: 'path',
                  selector: 'body'
              }, {
                  tagName: 'foreignObject',
                  selector: 'foreignObject',
                  attributes: {
                      'overflow': 'visible',
                  },
                  children: [{
                      tagName: 'input',
                      className: 'joint-link-label-input-divs',
                      selector: 'labelInputDiv',
                      namespaceURI: 'http://www.w3.org/1999/xhtml',
                      attributes: {
                          //'type': 'number',
                          'name': 'labelInputDiv',
                          'type': 'number',
                          'id': linkView.model.id + 'labelInputDiv'
                      }
                  }]
              }],

              attrs: {
                  body: {
                      refD: 'M 0 0 L 0 18 L 26 18 L 26 0 Z',
                      stroke: 'none',
                      fill: 'transparent',
                      yAlignment: 'middle',
                      // refY: 12,
                      refX: 0,
                      xAlignment: 'middle',
                  },
                  foreignObject: {
                      refWidth: '100%',
                      refHeight: '100%',
                      ref: 'body',
                      //yAlignment: 'middle',
                      refX: 0,
                      refY: 1.5,
                      //xAlignment: 'middle',
                      labelInputDiv: {
                          value: {
                              set: function (text, _, node) {
                                  if ('value' in node) {
                                      node.value = text;
                                  }
                              }
                          }
                      }
                  }
              },
              position: {
                  distance: 0.40
              }
          });
          if ((this.stream_Count == 0) || (this.stream_Count == 1)) { this.stream_Count = 1 }
          else {
            this.stream_Count -= 1
          }
          let try_Again = () => {
            this.stream_Count += 1
              if (!(this.stream_Number_Verification(this.stream_Count, linkView.model.id))) {
                  try_Again()
              }
          }
          if (!(this.stream_Number_Verification(this.stream_Count, linkView.model.id))) {
              try_Again()
          }

          linkView.model.label(0, { attrs: { 'labelInputDiv': { value: this.stream_Count } } });
          linkView.model.prop('CustomName', this.stream_Count)



          let link_Vertices = linkView.model.vertices()
          for (let i = 0; i < link_Vertices.length; i++) {
              linkView.model.removeVertex(-1)
          }

         
          updateLinksWithAgMatrix(this.graph, this)

      });

    }

    initializeSelection = () => {
        var selection = this.selection = new joint.ui.Selection({
            paper: this.paper,
            useModelGeometry: true,
            boxContent: false
        });

        // Initiate selecting when the user grabs the blank area of the paper.
        this.paper.on('blank:pointerdown', (evt, x, y) => {
            //console.log(paperScroller.zoom() <= baseline_Zoom)
            selection.collection.reset([]);

            if(!this.toolbarService) return;
            if(!this.toolbarService.selectedTool) this.toolbarService.selectedTool = 'pan';
            if(this.toolbarService.selectedTool != 'select') return;
            
                selection.startSelecting(evt)

            
        });

        // Select an element if CTRL/Meta key is pressed while the element is clicked.
        this.paper.on('element:pointerup', (cellView, evt) => {
            if ((evt.ctrlKey || evt.metaKey)) { 
                selection.collection.add(cellView.model);
            }
            else if (selection.collection.pluck('unitType').length <= 1) {
                selection.collection.reset([]);
                selection.collection.add(cellView.model);
            }
            else {
                selection.collection.reset([]);
            }

        });

        // Unselect an element if the CTRL/Meta key is pressed while a selected element is clicked.
        selection.on('selection-box:pointerdown', (elementView, evt) => {
            if (!(elementView.model.isLink()) && ((evt.ctrlKey || evt.metaKey))) { selection.collection.remove(elementView.model); }

        });

        this.paper.on('link:pointerup', (linkView, evt, x, y) => {
            this.paper.removeTools();
            selection.collection.reset([]);
            //Add vertices to the turning points
            let link_Svg_String = linkView.getSerializedConnection();
            link_Svg_String = link_Svg_String.replace('M ', '');
            let source_Point = linkView.model.getSourcePoint();
            let target_Point = linkView.model.getTargetPoint();
            let link_Path_Array = link_Svg_String.split(" L ");
            let link_Coordinates = [];
            for (let i = 0; i < link_Path_Array.length; i++) {
                link_Coordinates.push(link_Path_Array[i].split(" "))
            }
            let link_Vertices = linkView.model.vertices()
            for (let i = 0; i < link_Vertices.length; i++) {
                linkView.model.removeVertex(-1)
            }

            for (let i = 0; i < link_Coordinates.length; i++) {
                let vertex = { x: link_Coordinates[i][0], y: link_Coordinates[i][1] }
                if (!(((Math.abs(source_Point.x - vertex.x) < 5) && (Math.abs(source_Point.y - vertex.y) < 5)) || ((Math.abs(target_Point.x - vertex.x) < 5) && (Math.abs(target_Point.y - vertex.y) < 5)))) {
                    linkView.addVertex(parseInt(vertex.x, 10), parseInt(vertex.y, 10))
                }
            }
            linkView.removeRedundantLinearVertices()

            // Generate generic tools for all click points
            var verticesTool = new joint.linkTools.Vertices({
                focusOpacity: 0.5,
                redundancyRemoval: true,
                snapRadius: 20,
                vertexAdding: false
            })
            var segmentsTool = new joint.linkTools.Segments({ snapRadius: 30, redundancyRemoval: true })
            // Figure out click point
            linkView.model.prop('mouse_Enter_Entry_Point', { x: evt.pageX, y: evt.pageY })

            let mouse_Entry_Point = { x: evt.pageX, y: evt.pageY }
            let paper_Entry_Point = this.paper.pageToLocalPoint(mouse_Entry_Point)
            let distance_On_Link_To_Entry_Point = linkView.getClosestPointLength(paper_Entry_Point)
            let closest_Point_On_LinkView = linkView.getClosestPoint(paper_Entry_Point)
            let distance_From_Link_End_To_Entry_Point = linkView.getConnectionLength() - distance_On_Link_To_Entry_Point

            // I think we should extend this search radius to 25, so that you can insert a 30px shape with 10px padding room that wont disturb any bends
            let top_Center_Point = { x: closest_Point_On_LinkView.x, y: closest_Point_On_LinkView.y - 30 }
            let bottom_Center_Point = { x: closest_Point_On_LinkView.x, y: closest_Point_On_LinkView.y + 30 }
            let left_Center_Point = { x: closest_Point_On_LinkView.x - 30, y: closest_Point_On_LinkView.y }
            let right_Center_Point = { x: closest_Point_On_LinkView.x + 30, y: closest_Point_On_LinkView.y }

            let top_Point_Distance = Math.abs(linkView.getClosestPoint(top_Center_Point).y - top_Center_Point.y)
            let bottom_Point_Distance = Math.abs(linkView.getClosestPoint(bottom_Center_Point).y - bottom_Center_Point.y)
            let left_Point_Distance = Math.abs(linkView.getClosestPoint(left_Center_Point).x - left_Center_Point.x)
            let right_Point_Distance = Math.abs(linkView.getClosestPoint(right_Center_Point).x - right_Center_Point.x)

            // Find the two shortest distances
            let distance_Array = [top_Point_Distance, bottom_Point_Distance, left_Point_Distance, right_Point_Distance]
            let min_Two_Dists = distance_Array.sort((a, b) => a - b).slice(0, 2);
            // We have two cases, top & bottom and left & right,
            if (((top_Point_Distance in min_Two_Dists) && (bottom_Point_Distance in min_Two_Dists))
                || ((left_Point_Distance in min_Two_Dists) & (right_Point_Distance in min_Two_Dists))) {
                // it's either top bottom or left right
                // If you have room to play with
                if ((distance_On_Link_To_Entry_Point >= 33) && (distance_From_Link_End_To_Entry_Point >= 41)) {
                    var toolsView = new joint.dia.ToolsView({
                        name: 'my-link-tools',
                        tools: [
                            verticesTool,
                            segmentsTool,
                            // new joint.linkTools.InfoButton({ offset: 0, distance: distance_On_Link_To_Entry_Point + 22 }),
                            // new joint.linkTools.SplitButton({ distance: distance_On_Link_To_Entry_Point - 22 }),
                            // new joint.linkTools.ValveButton({ distance: distance_On_Link_To_Entry_Point }),
                            // new joint.linkTools.SensorButton({ distance: distance_On_Link_To_Entry_Point })

                        ]
                    });

                    linkView.addTools(toolsView);
                }
                // If you don't, then just the bare minimum
                else {
                    var toolsView = new joint.dia.ToolsView({
                        name: 'my-link-tools',
                        tools: [
                            verticesTool,
                            segmentsTool,
                            // new joint.linkTools.InfoButton({ offset: 0, distance: distance_On_Link_To_Entry_Point })
                        ]
                    });

                    linkView.addTools(toolsView);
                }

            }
            else {
                // theres a bend nearby, only show info button
                var toolsView = new joint.dia.ToolsView({
                    name: 'my-link-tools',
                    tools: [
                        verticesTool,
                        segmentsTool,
                        // new joint.linkTools.InfoButton({ offset: 0, distance: distance_On_Link_To_Entry_Point })
                    ]
                });
                linkView.addTools(toolsView);
            }


            selection.collection.add(linkView.model, { silent: true });

        });

        //this is the code responsible for assigning the unit type of feed and product tags.
        //basically this assigning whether a unit is a feed or product, depending on which end it's connected into
        //There needs to be logic to say if there's already an existing link in the other end, then it should not be assigned as a feed or product
        this.paper.on('link:connect', (linkView, evt, elementViewConnected, magnet, arrowhead) => {
            const sourceCell = this.graph.getCell(linkView.model.source().id);
            const targetCell = this.graph.getCell(linkView.model.target().id);

            if (sourceCell.attributes.type == 'pfd.FeedObject') {
                // Check if the feed object already has any incoming connections
                const incomingLinks = this.graph.getConnectedLinks(sourceCell, { inbound: true });
                
                let hasInboundConnections = incomingLinks.some(link => link.attributes.target.id === sourceCell.id);
                
                if (hasInboundConnections) {
                    // If there are incoming connections, prevent this new connection
                    linkView.model.remove();
                    // Optionally, show an alert or toast notification
                    console.log("Cannot connect to a Feed object that already has an incoming connection.");
                    return; // Exit the function early
                } else {
                    // If there are no incoming connections, set it as a Feed
                    sourceCell.prop('unitType', 'Feed');
                }
            }
            if (targetCell.attributes.type == 'pfd.FeedObject') {
                // Check if the product object already has any outgoing connections
                const outgoingLinks = this.graph.getConnectedLinks(targetCell, { outbound: true });
                
                let hasOutboundConnections = outgoingLinks.some(link => link.attributes.source.id === targetCell.id);
                
                if (hasOutboundConnections) {
                    // If there are outgoing connections, prevent this new connection
                    linkView.model.remove();
                    console.log("Cannot connect to a Product object that already has an outgoing connection.");
                    return; // Exit the function early
                } else {
                    // If there are no outgoing connections, set it as a Product
                    targetCell.prop('unitType', 'Product');
                }
            }
        })

        this.paper.on('link:snap:connect', (linkView, evt, elementViewConnected, magnet, arrowhead) => {
            this.hasUpdated(true)
              this.paper.removeTools();
              this.selection.collection.reset([]);
              if (elementViewConnected.model.prop('unitType') == 'pipework') {
                  linkView.model.target({
                      id: elementViewConnected.model.id, port: magnet.getAttribute('port'),
                      anchor: {
                          name: 'center'
                      }
                  });
                  if (magnet.getAttribute('port') == 'in_top_1') {
                      elementViewConnected.model.attr('topline/stroke', 'black')
                      elementViewConnected.model.attr('toplinearrow/fill', 'black')

                  }
                  if (magnet.getAttribute('port') == 'in_bottom_1') {
                      elementViewConnected.model.attr('bottomline/stroke', 'black')
                      elementViewConnected.model.attr('bottomlinearrow/fill', 'black')

                  }
                  if (magnet.getAttribute('port') == 'in_right_1') {
                      elementViewConnected.model.attr('rightline/stroke', 'black')
                      elementViewConnected.model.attr('rightlinearrow/fill', 'black')

                  }
                  if (magnet.getAttribute('port') == 'in_left_1') {
                      elementViewConnected.model.attr('leftline/stroke', 'black')
                      elementViewConnected.model.attr('leftlinearrow/fill', 'black')

                  }
                  elementViewConnected.model.attr('crosshairs/stroke', 'none')
                  elementViewConnected.model.attr('body/stroke', 'none')
                  elementViewConnected.model.attr('body/fill', 'transparent')
                  linkView.model.attr('line/targetMarker/d', 'M 0 0')

              }


              else if ((elementViewConnected.model.prop('unitType') == 'valve') && ((magnet.getAttribute('port') == 'out_top_1') || (magnet.getAttribute('port') == 'in_top_1'))) {
                  linkView.model.attr('line/targetMarker/d', 'M 0 0')
                  linkView.model.attr('line/stroke-dasharray', '2,2')
                  linkView.model.prop('CustomName', '')
                  linkView.model.removeLabel(-1)
              }
              else if ((elementViewConnected.model.prop('unitType') == 'valve') && (!((magnet.getAttribute('port') == 'out_top_1') || (magnet.getAttribute('port') == 'in_top_1')))) {
                  linkView.model.attr('line/targetMarker/d', 'M 0 0')
              }
              else if (elementViewConnected.model.prop('unitType') == 'Sensor') {
                  linkView.model.attr('line/targetMarker/d', 'M 0 0')
                  linkView.model.prop('CustomName', '')
                  linkView.model.removeLabel(-1)
              }
              else if (elementViewConnected.model.prop('unitType') == 'Controller') {
                  linkView.model.attr('line/targetMarker/d', 'M 0 0')
                  linkView.model.attr('line/stroke-dasharray', '2,2')
                  linkView.model.prop('CustomName', '')
                  linkView.model.removeLabel(-1)
              }
              else if (elementViewConnected.model.prop('unitType') == 'SensorConnector') {
                  linkView.model.attr('line/targetMarker/d', 'M 0 0')
                  linkView.model.prop('CustomName', '')
                  linkView.model.removeLabel(-1)
              }
              else {
                  linkView.model.target({
                      id: elementViewConnected.model.id, port: magnet.getAttribute('port'),
                      anchor: {
                          name: 'perpendicular'
                      }
                  });
              }


              if (linkView.model.source().id) {
                  let snapped_Link_Source_Id = linkView.model.source().id
                  let snapped_Link_Source_Port = linkView.model.source().port
                  if (this.graph.getCell(linkView.model.source().id).prop('unitType') == 'pipework') {
                      linkView.model.source({
                          id: snapped_Link_Source_Id, port: snapped_Link_Source_Port,
                          anchor: {
                              name: 'center'
                          }
                      });

                  }
                  else if ((this.graph.getCell(linkView.model.source().id).prop('unitType') == 'valve') && ((snapped_Link_Source_Port == 'in_top_1') || (snapped_Link_Source_Port == 'out_top_1'))) {
                      linkView.model.attr('line/targetMarker/d', 'M 0 0')
                      linkView.model.attr('line/stroke-dasharray', '2,2')
                      linkView.model.prop('CustomName', '')
                      linkView.model.removeLabel(-1)
                  }

                  else if (this.graph.getCell(linkView.model.source().id).prop('unitType') == 'Sensor') {
                      linkView.model.attr('line/targetMarker/d', 'M 0 0')
                      linkView.model.prop('CustomName', '')
                      linkView.model.removeLabel(-1)
                  }
                  else if (this.graph.getCell(linkView.model.source().id).prop('unitType') == 'Controller') {
                      linkView.model.attr('line/targetMarker/d', 'M 0 0')
                      linkView.model.attr('line/stroke-dasharray', '2,2')
                      linkView.model.prop('CustomName', '')
                      linkView.model.removeLabel(-1)
                  }
                  else if (this.graph.getCell(linkView.model.source().id).prop('unitType') == 'SensorConnector') {
                      linkView.model.attr('line/targetMarker/d', 'M 0 0')
                      linkView.model.prop('CustomName', '')
                      linkView.model.removeLabel(-1)
                  }
                  else {
                      linkView.model.source({
                          id: snapped_Link_Source_Id, port: snapped_Link_Source_Port,
                          anchor: {
                              name: 'perpendicular'
                          }
                      });
                  }

              }

              linkView.model.label(0, {
                markup: [{
                    tagName: 'path',
                    selector: 'body'
                }, {
                    tagName: 'foreignObject',
                    selector: 'foreignObject',
                    attributes: {
                        'overflow': 'visible',
                    },
                    children: [{
                        tagName: 'input',
                        className: 'joint-link-label-input-divs',
                        selector: 'labelInputDiv',
                        namespaceURI: 'http://www.w3.org/1999/xhtml',
                        attributes: {
                            //'type': 'number',
                            'name': 'labelInputDiv',
                            'type': 'number',
                            'id': linkView.model.id + 'labelInputDiv'
                        }
                    }]
                }],

                attrs: {
                    body: {
                        refD: 'M 0 0 L 0 18 L 26 18 L 26 0 Z',
                        stroke: 'none',
                        fill: 'transparent',
                        yAlignment: 'middle',
                        // refY: 12,
                        refX: 0,
                        xAlignment: 'middle',
                    },
                    foreignObject: {
                        refWidth: '100%',
                        refHeight: '100%',
                        ref: 'body',
                        //yAlignment: 'middle',
                        refX: 0,
                        refY: 1.5,
                        //xAlignment: 'middle',
                        labelInputDiv: {
                            value: {
                                set: function (text, _, node) {
                                    if ('value' in node) {
                                        node.value = text;
                                    }
                                }
                            }
                        }
                    }
                },
                position: {
                    distance: 0.40
                }
            });
            if ((this.stream_Count == 0) || (this.stream_Count == 1)) { this.stream_Count = 1 }
            else {
              this.stream_Count -= 1
            }
            let try_Again = () => {
              this.stream_Count += 1
                if (!(this.stream_Number_Verification(this.stream_Count, linkView.model.id))) {
                    try_Again()
                }
            }
            if (!(this.stream_Number_Verification(this.stream_Count, linkView.model.id))) {
                try_Again()
            }

            linkView.model.label(0, { attrs: { 'labelInputDiv': { value: this.stream_Count } } });
            linkView.model.prop('CustomName', this.stream_Count)

            linkView.model.router('manhattan', {
                startDirections: [linkView.model.source().port.split('_')[1]],
                endDirections: [magnet.getAttribute('port').split('_')[1]],
                padding: 10, step: 10
            })

            linkView.model.connector({ name: 'jumpover', args: { jump: 'gap', size: 4 } });

            //Add vertices to the turning points
            let link_Svg_String = linkView.getSerializedConnection();
            link_Svg_String = link_Svg_String.replace('M ', '');
            let source_Point = linkView.model.getSourcePoint();
            let target_Point = linkView.model.getTargetPoint();
            let link_Path_Array = link_Svg_String.split(" L ");
            let link_Coordinates = [];
            for (let i = 0; i < link_Path_Array.length; i++) {
                link_Coordinates.push(link_Path_Array[i].split(" "))
            }
            for (let i = 0; i < link_Coordinates.length; i++) {
                let vertex = { x: link_Coordinates[i][0], y: link_Coordinates[i][1] }
                if (!(((Math.abs(source_Point.x - vertex.x) < 5) && (Math.abs(source_Point.y - vertex.y) < 5)) || ((Math.abs(target_Point.x - vertex.x) < 5) && (Math.abs(target_Point.y - vertex.y) < 5)))) {
                    linkView.addVertex(parseInt(vertex.x, 10), parseInt(vertex.y, 10))
                }
            }
            linkView.removeRedundantLinearVertices()

            updateLinksWithAgMatrix(this.graph, this)
        });
    }

    initializeToolsAndInspector = () => {
    }

    initializeToolbar = () => {
      var paper = this.paper
      this.toolbarService.create(this.commandManager, this.paperScroller);

      this.toolbarService.toolbar.on('tool:select', () => {
        this.selection.collection.reset([]);
    });

      this.toolbarService.toolbar.on('feedback:pointerclick', () => {
        //console.log(JSON.stringify(graph.toJSON()))
        //anvil.call(anvil_Page_Node, 'feedback_Button_Click')
      });
      this.toolbarService.toolbar.on('print:pointerclick', (event) => {
        // Get text labels before printing
        const textLabels = this.textOverlayManager ? this.textOverlayManager.getLabelsForPrint() : [];

        paper.print({
            //padding: 10,
            sheet: { width: 297, height: 210 },
            poster: false,
            margin: 0,
            marginUnit: 'in',
            area: { width: 1587, height: 1123, x: 0, y: 0 },

            ready: (printAreaElements, readyToPrint) => {
                printAreaElements.forEach(($el) => {
                    $el.find('#paper').css('border', 'none');
                    $el.find('.shapename').css('border', 'none');
                    $el.find('.ql-blank').css('display', 'none');

                    // Add text labels to the print area
                    const svg = $el.find('svg')[0];
                    if (svg && textLabels.length > 0) {
                        textLabels.forEach(label => {
                            // Create a foreignObject to hold the HTML text
                            const foreignObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
                            foreignObject.setAttribute('x', label.x - label.width / 2);
                            foreignObject.setAttribute('y', label.y);
                            foreignObject.setAttribute('width', label.width);
                            foreignObject.setAttribute('height', '100');

                            // Create the div to hold the text content
                            const div = document.createElement('div');
                            div.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');
                            div.innerHTML = label.html;
                            div.style.cssText = 'font-family: Arial, sans-serif; font-size: 14px; text-align: center; color: black;';

                            foreignObject.appendChild(div);
                            svg.appendChild(foreignObject);
                        });
                    }
                });
                //console.log(printAreaElements)
                readyToPrint(printAreaElements);
            }
        });
      });

      this.toolbarService.toolbar.on('download:pointerclick', (event) => {
        var graphJson = this.getGraphJSONSave()
        var json_String = JSON.stringify(graphJson);

        var a = document.createElement("a");
        var file = new Blob([json_String], { type: 'text/plain' });
        a.href = URL.createObjectURL(file);
        let d = new Date()
        var ampm = d.getHours() >= 12 ? 'pm' : 'am';
        let diagram_name = this.graphName
        a.download = diagram_name + ' ' + d.getDate() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + d.getFullYear() + ' ' + String(d.getHours()).padStart(2, '0') + String(d.getMinutes()).padStart(2, '0') + ampm + '.json';
        a.click();
      })

      this.toolbarService.toolbar.on('upload:pointerclick', (event) => {
        var el = window._protected_reference = document.createElement("INPUT");
        el.type = "file";
        el.accept = "application/json";

        //el.multiple = "multiple"; // remove to have a single file selection

        // (cancel will not trigger 'change')
        el.addEventListener('change', (ev2) => {
            this.hasUpdated(true)
            // access el.files[] to do something with it (test its length!)

            // add first image, if available
            if (el.files.length) {
                //document.getElementById('out').src = URL.createObjectURL(el.files[0]);
                var fr = new FileReader();
                fr.onload = () => {
                    //console.log(fr.result);
                    let graphJSON = {
                        cells: JSON.parse(fr.result).cells || []
                    }

                    this.graph.fromJSON(graphJSON);

                    // Initialize text overlay editors for existing shapes
                    if (this.textOverlayManager) {
                        setTimeout(() => {
                            this.textOverlayManager.initializeExistingShapes();
                        }, 100);
                    }

                    var loaded_Shapes = this.graph.getElements();
                    var loaded_Links = this.graph.getLinks();
                    for (var i = 0; i < loaded_Links.length; i++) {
                        if (document.getElementById(loaded_Links[i].id + "PropertyDiv")) {
                            //
                            document.getElementById(loaded_Links[i].id + "PropertyDiv").remove()
                        }
                    }
                    for (var i = 0; i < loaded_Shapes.length; i++) {
                        if (loaded_Shapes[i].prop('filename')) {
                            document.getElementById('title-block-project-name-site').value = loaded_Shapes[i].prop('filename');
                        }
                        if (loaded_Shapes[i].attributes.type == 'dwgtemplate.logoBlock2') {
                          this.graph.removeCells(loaded_Shapes[i])
                        }
                        if (loaded_Shapes[i].attributes.type == 'dwgtemplate.logoBlock1') {
                            loaded_Shapes[i].resize(228, 119)
                            loaded_Shapes[i].position(1359, 843)
                        }
                        if (loaded_Shapes[i].attributes.type == 'dwgtemplate.titleBlock') {
                            loaded_Shapes[i].position(1359, 961)
                        }
                        if (loaded_Shapes[i].attributes.type == 'dwgtemplate.titleBlock2') {
                            loaded_Shapes[i].position(1358, 1030)
                        }
                        if (loaded_Shapes[i].attributes.type == 'dwgtemplate.revisionBlock') {
                            loaded_Shapes[i].position(1358, 1099)
                        }
                        // TextOverlayManager.initializeExistingShapes() handles text editors for units
                    }


                }
                fr.readAsText(el.files[0])

            }


            // test some async handling
            new Promise(function (resolve) {
                setTimeout(function () { console.log(el.files); resolve(); }, 1000);
            })
                .then(function () {
                    // clear / free reference
                    el = window._protected_reference = undefined;
                });

        });

        el.click(); // open
      })
      this.toolbarService.toolbar.on('home:pointerclick', (event) => {
        if(this.isUpdated()) this.openConfirmPopup()
        else this.navigate("/")
      })

      this.toolbarService.toolbar.on('save-as:pointerclick', (event) => {
        this.toggleSaveNamePopup()
    })

    this.toolbarService.toolbar.on('save-json:pointerclick', (event) => {
        this.saveGraph(this.graphGroup)
    })

    this.toolbarService.toolbar.on('switch-simulator:pointerclick', async (event) => {
        this.setGraphData(this.getGraphJSONSave(), this.graphName)
        this.useSimulator(this.uuid)
    })

      this.renderPlugin('.toolbarContainer', this.toolbarService.toolbar);
  }

    saveGraph = async (graphGroup) => {
        //console.log(this.graphName)
        if(this.graphName == null || this.graphName == ""){
            this.toggleSaveNamePopup()
            return true;
        }

        if(this.hitSaveOnce) return false;
        if(this.hitSaveOnce && this.uuid == null) return false;
        if(!this.hitSaveOnce) this.hitSaveOnce = true
        if(this.uuid == "new") this.uuid = null
          // Only update this.graphGroup if graphGroup is provided
        if (graphGroup !== undefined && graphGroup !== null) {
            this.graphGroup = graphGroup;
        }
        console.log(graphGroup)
        var graphData = this.getGraphJSONSave()
        //console.log(JSON.stringify(graphData))

        console.log("Graph Data before API call:", graphData);

        await FlowireAPI.authPost('/api/save', graphData, this.getIdTokenClaims, this.isAuthenticated, (error) => {
            console.error("Error saving graph: ", error);
            if(error.status == 405){
                toast.error("Error saving graph: No permission to save this graph.")
            } else {
                toast.error("Error saving graph: " + error.statusText)
            }
        }).then((ans) => {
            if(ans.uuid){
                this.uuid = ans.uuid
                toast.success("Successfully Saved Simulation!")
                this.hasUpdated(true)
            }
        })

        if(this.hitSaveOnce) this.hitSaveOnce = false
        return false
    }

    getGraphJSONSave() {
        var graphData = this.graph.toJSON();
         // If econVars exist (i.e. from a prior simulator session), include them.
        if (this.econVars) {
            graphData.econVars = this.econVars;
        }
        Object.assign(graphData, {
            'uuid': this.uuid,
            'graphName': this.graphName,
            'designer': false,
            'group_uuid': this.graphGroup // Use the existing or updated this.graphGroup
        });
    
        return graphData;
    }
    
    loadJSON = (graphName, uuid, json, updated) => {
        console.log('Designer loadJSON called, cells:', json.cells?.length);
        this.graphName = graphName
        this.uuid = uuid
        let graphJSON = {
            cells: json.cells || []
        }

        this.graph.fromJSON(graphJSON);

        if (json.econVars) {
            this.econVars = json.econVars;
          }

        //initialize the unit numbering service on load
        if (this.unitNumberingService) {
            this.unitNumberingService.initializeExistingUnits();
          }

        // Initialize text overlay editors for existing shapes
        console.log('Designer loadJSON: textOverlayManager exists?', !!this.textOverlayManager);
        if (this.textOverlayManager) {
            setTimeout(() => {
                console.log('Designer loadJSON: calling initializeExistingShapes');
                this.textOverlayManager.initializeExistingShapes();
            }, 100);
        }

        if(graphJSON.cells.length === 0) {
            let left_border_shape = new joint.shapes.dwgtemplate.sideBorderShape();
            let right_border_shape = new joint.shapes.dwgtemplate.sideBorderShape();
            let top_border_shape = new joint.shapes.dwgtemplate.topBorderShape();
            let bottom_border_shape = new joint.shapes.dwgtemplate.topBorderShape();
            left_border_shape.position(0, 0)
            right_border_shape.position(1586-1, 0)
            top_border_shape.position(0, 0)
            bottom_border_shape.position(0, 1122)

            // Add to graph
            this.graph.addCells(left_border_shape, right_border_shape, top_border_shape, bottom_border_shape)
        }

        var loaded_Shapes = this.graph.getElements();
        var loaded_Links = this.graph.getLinks();
        for (var i = 0; i < loaded_Links.length; i++) {
            if (document.getElementById(loaded_Links[i].id + "PropertyDiv")) {
                //
                document.getElementById(loaded_Links[i].id + "PropertyDiv").remove()
            }
        }
        for (var i = 0; i < loaded_Shapes.length; i++) {
            if (loaded_Shapes[i].prop('filename')) {
                document.getElementById('title-block-project-name-site').value = loaded_Shapes[i].prop('filename');
            }
            if (loaded_Shapes[i].attributes.type == 'dwgtemplate.logoBlock2') {
              this.graph.removeCells(loaded_Shapes[i])
            }
            if (loaded_Shapes[i].attributes.type == 'dwgtemplate.logoBlock1') {
                loaded_Shapes[i].resize(228, 119)
                loaded_Shapes[i].position(1359, 843)
            }
            if (loaded_Shapes[i].attributes.type == 'dwgtemplate.titleBlock') {
                loaded_Shapes[i].position(1359, 961)
            }
            if (loaded_Shapes[i].attributes.type == 'dwgtemplate.titleBlock2') {
                loaded_Shapes[i].position(1358, 1030)
            }
            if (loaded_Shapes[i].attributes.type == 'dwgtemplate.revisionBlock') {
                loaded_Shapes[i].position(1358, 1099)
            }
            // TextOverlayManager.initializeExistingShapes() handles text editors for units
        }

        this.hasUpdated(updated)
    }

    initializeKeyboardShortcuts = () => {
        const rappid = this.rappidContext;

        var clipboard = new joint.ui.Clipboard({
            translate: { dx: 20, dy: 20 },
            useLocalStorage: true
        });

        var keyboard = this.keyboard = new joint.ui.Keyboard();
        keyboard.on({
                'delete backspace': (evt) => {
                    evt.preventDefault();
                    try {
                        // Get selected cells that will be deleted
                        const cellsToDelete = this.selection.collection.toArray();
                        
                        // Handle each cell's connections before deletion
                        cellsToDelete.forEach(cell => {

                        // Handle unit numbering for deletion
                        if (this.unitNumberingService && !cell.isLink() && cell.prop('unitNumber')) {
                            this.unitNumberingService.handleUnitDeletion(cell);
                        }

                            if (cell.isLink()) {
                                // If it's a link, handle the connected elements
                                const sourceCell = this.graph.getCell(cell.get('source').id);
                                const targetCell = this.graph.getCell(cell.get('target').id);
                                
                                // Handle source cell if it's pipework
                                if (sourceCell && sourceCell.prop('unitType') === 'pipework') {
                                    const port = cell.get('source').port;
                                    const remainingLinks = this.graph.getConnectedLinks(sourceCell).filter(link => link.id !== cell.id);
                                    
                                    // Check remaining connections on this side
                                    const remainingPorts = remainingLinks.map(link => 
                                        link.get('source').id === sourceCell.id ? link.get('source').port : link.get('target').port
                                    );
                                    
                                    // Handle arrows and lines based on port
                                    if (port.includes('out_top')) {
                                        if (!remainingPorts.some(p => p.includes('_top_'))) {
                                            sourceCell.attr('topline/stroke', 'none');
                                        }
                                    } else if (port.includes('out_bottom')) {
                                        if (!remainingPorts.some(p => p.includes('_bottom_'))) {
                                            sourceCell.attr('bottomline/stroke', 'none');
                                        }
                                    } else if (port.includes('out_right')) {
                                        if (!remainingPorts.some(p => p.includes('_right_'))) {
                                            sourceCell.attr('rightline/stroke', 'none');
                                        }
                                    } else if (port.includes('out_left')) {
                                        if (!remainingPorts.some(p => p.includes('_left_'))) {
                                            sourceCell.attr('leftline/stroke', 'none');
                                        }
                                    }
                                    
                                    // If no connections remain, restore default appearance
                                    if (remainingLinks.length === 0) {
                                        sourceCell.attr('crosshairs/stroke', 'black');
                                        sourceCell.attr('body/stroke', 'none');
                                        sourceCell.attr('body/fill', 'white');
                                    }
                                }
                                
                                // Handle target cell if it's pipework
                                if (targetCell && targetCell.prop('unitType') === 'pipework') {
                                    const port = cell.get('target').port;
                                    const remainingLinks = this.graph.getConnectedLinks(targetCell).filter(link => link.id !== cell.id);
                                    
                                    // Check remaining connections on this side
                                    const remainingPorts = remainingLinks.map(link => 
                                        link.get('source').id === targetCell.id ? link.get('source').port : link.get('target').port
                                    );
                                    
                                    // Handle arrows and lines based on port
                                    if (port.includes('in_top')) {
                                        targetCell.attr('toplinearrow/fill', 'none');
                                        if (!remainingPorts.some(p => p.includes('_top_'))) {
                                            targetCell.attr('topline/stroke', 'none');
                                        }
                                    } else if (port.includes('in_bottom')) {
                                        targetCell.attr('bottomlinearrow/fill', 'none');
                                        if (!remainingPorts.some(p => p.includes('_bottom_'))) {
                                            targetCell.attr('bottomline/stroke', 'none');
                                        }
                                    } else if (port.includes('in_right')) {
                                        targetCell.attr('rightlinearrow/fill', 'none');
                                        if (!remainingPorts.some(p => p.includes('_right_'))) {
                                            targetCell.attr('rightline/stroke', 'none');
                                        }
                                    } else if (port.includes('in_left')) {
                                        targetCell.attr('leftlinearrow/fill', 'none');
                                        if (!remainingPorts.some(p => p.includes('_left_'))) {
                                            targetCell.attr('leftline/stroke', 'none');
                                        }
                                    }
                                    
                                    // If no connections remain, restore default appearance
                                    if (remainingLinks.length === 0) {
                                        targetCell.attr('crosshairs/stroke', 'black');
                                    }
                                }
                            }
                        });

                        this.graph.removeCells(cellsToDelete);
                        this.selection.collection.reset([]);
                        updateLinksWithAgMatrix(this.graph, this)
                    } catch (error) {
                        console.error('Error occurred during cell removal:', error);
                    }
                },
                'ctrl+z': (evt) => {
                  evt.preventDefault();
                  try {
                    this.commandManager.undo();
                    this.selection.collection.reset([]);
                  } catch (error) {
                    console.error('Error occurred during undo operation:', error);
                  }
                },
                'ctrl+y': (evt) => {
                  evt.preventDefault();
                  try {
                    this.commandManager.redo();
                    this.selection.collection.reset([]);
                  } catch (error) {
                    console.error('Error occurred during redo operation:', error);
                  }
                },
                //Copy pasted disabled due to Quill's not being copy and pasted correctly
                /*
                'ctrl+x': (evt) => {
                  evt.preventDefault();
                  try {
                    clipboard.cutElements(this.selection.collection, this.paper.model);
                  } catch (error) {
                    console.error('Error occurred during cut operation:', error);
                  }
                },
                'ctrl+c': (evt) => {
                  evt.preventDefault();
                  try {
                    clipboard.copyElements(this.selection.collection, this.paper.model);
                  } catch (error) {
                    console.error('Error occurred during copy operation:', error);
                  }
                },
                'ctrl+v': (evt) => {
                  evt.preventDefault();
                  try {
                    clipboard.pasteCells(this.paper.model);
                  } catch (error) {
                    console.error('Error occurred during paste operation:', error);
                  }
                }*/
            }
        );
    }

    renderPlugin(selector, plugin) {
        this.el.querySelector(selector).appendChild(plugin.el);
        plugin.render();
    }

    dragElement(elmnt) {
      var graph = this.graph
      var paper = this.paper
      let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
      // Move the DIV from anywhere inside the DIV:
      let cursorChange = (e) => {
          e = e || window.event;
          //e.preventDefault();
          let cursorRect = e.target.getBoundingClientRect();
          //get right corner mouse enter event
          let posx = cursorRect.right - e.clientX; //right corner  position within the element.
          let posy = cursorRect.bottom - e.clientY; //y position within the element.
      }

      let dragMouseDown = (e) => {
          var moved = false;
          e = e || window.event;
          if (e.target.getAttribute('class') != null) {
              if ((e.target.getAttribute('class').indexOf('process-shape') !== -1)) {
                  // everything goes here
                  //e.preventDefault();
                  // get the mouse cursor position at startup:
                  pos3 = e.clientX;
                  pos4 = e.clientY;
                  let rect = e.target.getBoundingClientRect();
                  //get right corner click event
                  let posx = rect.right - e.clientX; //right corner  position within the element.
                  let posy = rect.bottom - e.clientY; //y position within the element.



                  // THIS IS WHAT NEEDS TO BE SMART
                  let elementDrag = (e) => {
                      e = e || window.event;

                      e.preventDefault();
                      // calculate the new cursor position:
                      pos1 = pos3 - e.clientX;
                      pos2 = pos4 - e.clientY;
                      pos3 = e.clientX;
                      pos4 = e.clientY;
                      // set the element's new position:
                      let joint_Shape_ID = elmnt.id.replace('QuillDiv', '');
                      let joint_Element = graph.getCell(joint_Shape_ID)

                      joint_Element.position(joint_Element.position().x + (elmnt.offsetLeft - pos1) / this.paperScroller.zoom(), joint_Element.position().y + (elmnt.offsetTop - pos2) / this.paperScroller.zoom())
                      moved = true
                  }

                  let closeDragElement = () => {
                      // stop moving when mouse button is released:
                      document.onmouseup = null;
                      document.onmousemove = null;
                      if (!(moved)) {

                          let joint_Shape_ID = elmnt.id.replace('QuillDiv', '');
                          let joint_Element = graph.getCell(joint_Shape_ID)
                          let cellView = paper.findViewByModel(joint_Element)
                          if ((e.ctrlKey || e.metaKey)) {
                              this.selection.collection.add(cellView.model);
                              // No need for the resize halo here
                          }
                          else if (this.selection.collection.pluck('unitType').length <= 1) {
                              this.selection.collection.reset([]);
                              this.selection.collection.add(cellView.model);
                              // solo selection warrants halo for resizing
															this.createPointerHalo(cellView)

                              var freeTransform = new joint.ui.FreeTransform({ cellView: cellView });
                              freeTransform.render();
                          }
                          else {
                              this.selection.collection.reset([]);
                          }
                      }




                  }
                  // call a function whenever the cursor moves:
                  document.onmousemove = elementDrag;
                  document.onmouseup = closeDragElement;

              }
          }
      }

      elmnt.onmousemove = cursorChange;
      elmnt.onmousedown = dragMouseDown;
  }


  dragElementShapes(elmnt) {
      let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
      // Move the DIV from anywhere inside the DIV:
      let cursorChange = (e) => {
        e = e || window.event;
        //e.preventDefault();
        let cursorRect = e.target.getBoundingClientRect();
        //get right corner mouse enter event
        let posx = cursorRect.right - e.clientX; //right corner  position within the element.
        let posy = cursorRect.bottom - e.clientY; //y position within the element.

        if (posx < 10 && posy < 10) {
            //bottom right corner moused over
            elmnt.style.cursor = 'nwse-resize'
            function returnCursorStyle() {
                elmnt.style.cursor = 'move'
            }
            elmnt.onmouseleave = returnCursorStyle;
        }
        else {
            elmnt.style.cursor = 'move'
        }
    }

    let dragMouseDown = (e) => {

        e = e || window.event;

        if (e.target.getAttribute('class') != null) {
            if ((e.target.getAttribute('class').indexOf('ql-container') !== -1) || (e.target.getAttribute('class').indexOf('process-shape') !== -1)) {
                // THE DRAGGABLE PART OF THE DIV
                //e.preventDefault();
                // get the mouse cursor position at startup:
                pos3 = e.clientX;
                pos4 = e.clientY;
                let rect = e.target.getBoundingClientRect();
                //get right corner click event
                let posx = rect.right - e.clientX; //right corner  position within the element.
                let posy = rect.bottom - e.clientY; //y position within the element.

                if (posx < this.paperScroller.zoom() * 20 && posy < this.paperScroller.zoom() * 20) {
                    //bottom right corner clicked
                    let elementResize = (e) => {
                        e = e || window.event;
                        e.preventDefault();
                        // calculate the new cursor position:
                        pos1 = (pos3 - e.clientX);
                        pos2 = (pos4 - e.clientY);
                        // set the element's new size:
                        let new_width = (e.clientX - pos3) / this.paperScroller.zoom() + parseInt(elmnt.style.width, 10);
                        let new_height = (e.clientY - pos4) / this.paperScroller.zoom() + parseInt(elmnt.style.height, 10);
                        if ((60 < new_width) && (new_width < 500) && (15 < new_height) && (new_height < 500)) {
                            elmnt.style.width = new_width + "px";
                            elmnt.style.height = new_height + "px";
                        }
                        pos3 = e.clientX;
                        pos4 = e.clientY;
                    }
                    function closeResizeElement() {
                        // stop resizing when mouse button is released:
                        document.onmouseup = null;
                        document.onmousemove = null;
                    }
                    // call a function whenever the cursor moves:
                    document.onmousemove = elementResize;
                    document.onmouseup = closeResizeElement;
                }
                else {
                    let elementDrag = (e) => {
                        e = e || window.event;
                        e.preventDefault();
                        // calculate the new cursor position:
                        pos1 = (pos3 - e.clientX) / this.paperScroller.zoom();
                        pos2 = (pos4 - e.clientY) / this.paperScroller.zoom();
                        pos3 = e.clientX;
                        pos4 = e.clientY;
                        // set the element's new position:
                        //elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
                        //elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
                        let cell = this.graph.getCell(elmnt.id.replace('QuillDiv', ''))
                        //if ((elmnt.style.top == '') && (elmnt.style.left == '')) {
                        //cell.attr('foreignObject/refX', '0%')
                        //cell.attr('foreignObject/refY', '0%')
                        //cell.attr('shapename/style/top', (1.2 * cell.size().height + elmnt.offsetTop - pos2) + "px")
                        //cell.attr('shapename/style/left', (elmnt.offsetLeft - pos1) + "px")
                        //}
                        //else {
                        //cell.attr('foreignObject/refX', '0%')
                        //cell.attr('foreignObject/refY', '0%')
                        cell.attr('shapename/style/top', (elmnt.offsetTop - pos2) + "px")
                        cell.attr('shapename/style/left', (elmnt.offsetLeft - pos1) + "px")
                        //}
                    }
                    function closeDragElement() {
                        // stop moving when mouse button is released:
                        document.onmouseup = null;
                        document.onmousemove = null;
                    }
                    // call a function whenever the cursor moves:
                    document.onmousemove = elementDrag;
                    document.onmouseup = closeDragElement;
                }
            }

        }


    }

      elmnt.onmousemove = cursorChange;
      elmnt.onmousedown = dragMouseDown;
  }

  dragElementDiv(elmnt) {
    let dragMouseDown = (e) => {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }

    let elementDrag = (e) => {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
    }

      var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
      if (document.getElementById(elmnt.id + "header")) {
          // if present, the header is where you move the DIV from:
          document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
      } else {
          //otherwise, move the DIV from anywhere inside the DIV:
          elmnt.onmousedown = dragMouseDown;
      }
  }

  hideDataEntryDiv(divName) {
      var divToHide;
      divToHide = document.getElementById(divName);
      divToHide.remove();
  }

  stream_Number_Verification(stream_Number, stream_Id) {
      var graph = this.graph
      let result = true
      let existing_Links = graph.getLinks()
      for (let i = 0; i < existing_Links.length; i++) {
          if (stream_Number == parseInt(existing_Links[i].prop('CustomName'))) {
              //console.log('false')
              if (existing_Links[i].id != stream_Id) { result = false }
          }
          else {
              continue
          }
      }
      //console.log('true')
      return result

  }



  stream_Property_Popup(link_Id) {
      //alert("Stream Data Module not available in demo version.")
      if (!document.getElementById(link_Id + "PropertyDiv")) {
          //It does not exist
          let stream_Div = document.createElement('div');
          document.body.appendChild(stream_Div);
          stream_Div.setAttribute('id', link_Id + 'PropertyDiv');
          stream_Div.classList.add("stream-property-div");
          let stream = graph.getCell(link_Id);
          let link_View = paper.findViewByModel(stream);
          let targ = paper.$el.offset();
          let pos = link_View.getBBox(),
              offset = {
                  x: pos.x,
                  y: pos.y + pos.height / 2
              };
          stream_Div.style.top = targ.top + offset.y + 20 + 'px';
          stream_Div.style.left = targ.left + offset.x + 'px';

          let newHeaderDiv = document.createElement("div")
          newHeaderDiv.setAttribute("id", stream_Div.id + "header")
          newHeaderDiv.classList.add("stream-property-div-header");

          newHeaderDiv.textContent = "Stream " + stream.label(0).attrs.labelInputDiv.value + " Properties"
          stream_Div.appendChild(newHeaderDiv)

          let newDivHideButton = document.createElement("BUTTON")
          newDivHideButton.setAttribute("id", stream_Div.id + "hide")
          stream_Div.appendChild(newDivHideButton)
          newDivHideButton.classList.add("close-stream-property-button")
          newDivHideButton.textContent = "X"
          newDivHideButton.style.color = 'red'
          newDivHideButton.addEventListener("click", () => { this.hideDataEntryDiv(stream_Div.id); });
          this.dragElementDiv(stream_Div);
          let stream_Div_Description = document.createElement("textarea");
          stream_Div_Description.setAttribute('placeholder', "Description...")
          stream_Div_Description.style.resize = "vertical";
          stream_Div_Description.style.float = "left";
          stream_Div_Description.style.width = "100%";
          stream_Div.appendChild(stream_Div_Description);
          if (stream.prop('stream_Description')) {
              stream_Div_Description.value = stream.prop('stream_Description')
          }
          function update_Stream_Description(evt) {
              stream.prop('stream_Description', evt.target.value)
          }
          stream_Div_Description.addEventListener("change", update_Stream_Description)

          let stream_Div_Section_2 = document.createElement("div")
          stream_Div_Section_2.classList.add("stream-property-bottom-half");
          stream_Div.appendChild(stream_Div_Section_2);

          let stream_Div_New_Property_Label_Input = document.createElement("input");
          stream_Div_New_Property_Label_Input.classList.add('stream-property-input')
          stream_Div_New_Property_Label_Input.id = link_Id + 'New_Property_Name'

          stream_Div_Section_2.appendChild(stream_Div_New_Property_Label_Input)
          stream_Div_New_Property_Label_Input.setAttribute('placeholder', 'Property')
          let stream_Div_New_Property_Value_Input = document.createElement("input");
          stream_Div_New_Property_Value_Input.classList.add('stream-property-input')
          stream_Div_New_Property_Value_Input.id = link_Id + 'New_Value_Input'
          stream_Div_Section_2.appendChild(stream_Div_New_Property_Value_Input)
          stream_Div_New_Property_Value_Input.setAttribute('placeholder', 'Value')
          let stream_Div_New_Property_Units_Input = document.createElement("input");
          stream_Div_New_Property_Units_Input.classList.add('stream-property-input')
          stream_Div_New_Property_Units_Input.id = link_Id + 'New_Units_Input'
          stream_Div_Section_2.appendChild(stream_Div_New_Property_Units_Input)
          stream_Div_New_Property_Units_Input.setAttribute('placeholder', 'Units')

          let stream_Div_New_Property_Add_Button = document.createElement("BUTTON");
          stream_Div_New_Property_Add_Button.classList.add('stream-property-button')
          stream_Div_Section_2.appendChild(stream_Div_New_Property_Add_Button)
          stream_Div_New_Property_Add_Button.textContent = 'ADD'
          stream_Div_New_Property_Add_Button.id = link_Id + 'Add_Button'

          let stream_Property_Added = (event) => {
              //
              let stream_Id = event.target.id.replace('Add_Button', '')
              let stream = graph.getCell(stream_Id)

              let stream_Div_New_Property_Label_Input = document.getElementById(stream_Id + 'New_Property_Name')
              let stream_Div_New_Property_Value_Input = document.getElementById(stream_Id + 'New_Value_Input')
              let stream_Div_New_Property_Units_Input = document.getElementById(stream_Id + 'New_Units_Input')
              try {
                  let stream_Objects = stream.attributes['stream_Properties']
                  let listed_Stream_Objects = Object.keys(stream_Objects)
                  if (stream_Div_New_Property_Label_Input.value in listed_Stream_Objects) {
                      return
                  }
                  else {
                      //
                  }
              }
              catch (e) {
                  if (e instanceof TypeError) {
                      //
                  }
              }
              if (stream_Div_New_Property_Label_Input.value != '') {
                  // It doesn't exist and it's not empty str
                  let Property_Name = stream_Div_New_Property_Label_Input.value
                  let Property_Value = stream_Div_New_Property_Value_Input.value
                  let Property_Units = stream_Div_New_Property_Units_Input.value

                  let new_Stream_Div_Property_Label_Input = document.createElement("div")
                  new_Stream_Div_Property_Label_Input.classList.add('stream-property-label')
                  stream_Div_Section_2.appendChild(new_Stream_Div_Property_Label_Input)
                  new_Stream_Div_Property_Label_Input.textContent = Property_Name
                  new_Stream_Div_Property_Label_Input.id = stream_Id + Property_Name + 'Label_Input'
                  stream_Div_New_Property_Label_Input.value = ''

                  let new_Stream_Div_Property_Value_Input = document.createElement("input")
                  new_Stream_Div_Property_Value_Input.classList.add('stream-property-input')
                  stream_Div_Section_2.appendChild(new_Stream_Div_Property_Value_Input)
                  new_Stream_Div_Property_Value_Input.setAttribute('placeholder', 'Value')
                  new_Stream_Div_Property_Value_Input.value = Property_Value
                  new_Stream_Div_Property_Value_Input.id = stream_Id + Property_Name + 'Value_Input'
                  new_Stream_Div_Property_Value_Input.setAttribute("data-PropertyName", Property_Name)
                  stream_Div_New_Property_Value_Input.value = ''
                  let update_Property_Value = (event) => {
                      let new_Value = event.target.value
                      let prop_Name = event.target.getAttribute("data-PropertyName")
                      let stream_Id = event.target.id.replace('Value_Input', '')
                      stream_Id.replace(prop_Name, '')
                      graph.getCell(stream_Id).prop({ 'stream_Properties': { prop_Name: { 'Value': new_Value } } })
                  }
                  new_Stream_Div_Property_Value_Input.addEventListener("change", update_Property_Value)

                  let new_Stream_Div_Property_Units_Input = document.createElement("input")
                  new_Stream_Div_Property_Units_Input.classList.add('stream-property-input')
                  stream_Div_Section_2.appendChild(new_Stream_Div_Property_Units_Input)
                  new_Stream_Div_Property_Units_Input.setAttribute('placeholder', 'Units')
                  new_Stream_Div_Property_Units_Input.value = Property_Units
                  new_Stream_Div_Property_Units_Input.id = stream_Id + Property_Name + 'Units_Input'
                  new_Stream_Div_Property_Units_Input.setAttribute("data-PropertyName", Property_Name)
                  stream_Div_New_Property_Units_Input.value = ''
                  let update_Property_Units = (event) => {
                      let new_Units = event.target.value
                      let prop_Name = event.target.getAttribute("data-PropertyName")
                      let stream_Id = event.target.id.replace('Units_Input', '')
                      stream_Id.replace(prop_Name, '')
                      graph.getCell(stream_Id).prop({ 'stream_Properties': { prop_Name: { 'Units': new_Units } } })
                  }
                  new_Stream_Div_Property_Units_Input.addEventListener("change", update_Property_Units)

                  let new_Stream_Div_Property_Remove_Button = document.createElement("BUTTON")
                  new_Stream_Div_Property_Remove_Button.classList.add('stream-property-button')
                  stream_Div_Section_2.appendChild(new_Stream_Div_Property_Remove_Button)
                  new_Stream_Div_Property_Remove_Button.textContent = ' X '
                  new_Stream_Div_Property_Remove_Button.style.color = 'red'
                  new_Stream_Div_Property_Remove_Button.id = stream_Id + 'Remove_Button' + Property_Name
                  let stream_Property_Removed = (event) => {
                      //
                      let stream_Property_Identifier = event.target.id.replace('Remove_Button', '')
                      let Property_Name = event.target.id.slice(event.target.id.indexOf('Remove_Button') + 13)
                      document.getElementById(stream_Property_Identifier + 'Label_Input').remove()
                      document.getElementById(stream_Property_Identifier + 'Value_Input').remove()
                      document.getElementById(stream_Property_Identifier + 'Units_Input').remove()
                      event.target.remove()
                      delete stream.attributes['stream_Properties'][Property_Name]
                  }
                  new_Stream_Div_Property_Remove_Button.addEventListener("click", stream_Property_Removed)
                  stream.prop({ 'stream_Properties': { [Property_Name]: { 'Value': Property_Value, 'Units': Property_Units } } })
              }
          }
          stream_Div_New_Property_Add_Button.addEventListener("click", stream_Property_Added)

          // Add all the rows based on all the properties
          try {
              let stream_Objects = stream.attributes['stream_Properties']
              let listed_Stream_Objects = Object.keys(stream_Objects)
              // for loop
              for (let i = 0; i < listed_Stream_Objects.length; i++) {
                  let stream_Prop = listed_Stream_Objects[i]

                  let stream_Prop_Contents = stream_Objects[stream_Prop]
                  let stream_Prop_Name = stream_Prop
                  let stream_Prop_Value = stream_Prop_Contents['Value']
                  let stream_Prop_Units = stream_Prop_Contents['Units']

                  let next_Stream_Div_Property_Label_Input = document.createElement("div")
                  next_Stream_Div_Property_Label_Input.classList.add('stream-property-label')
                  stream_Div_Section_2.appendChild(next_Stream_Div_Property_Label_Input)
                  next_Stream_Div_Property_Label_Input.textContent = stream_Prop_Name
                  next_Stream_Div_Property_Label_Input.id = link_Id + stream_Prop_Name + 'Label_Input'

                  let next_Stream_Div_Property_Value_Input = document.createElement("input")
                  next_Stream_Div_Property_Value_Input.classList.add('stream-property-input')
                  stream_Div_Section_2.appendChild(next_Stream_Div_Property_Value_Input)
                  next_Stream_Div_Property_Value_Input.setAttribute('placeholder', 'Value')
                  next_Stream_Div_Property_Value_Input.value = stream_Prop_Value
                  next_Stream_Div_Property_Value_Input.id = link_Id + stream_Prop_Name + 'Value_Input'
                  next_Stream_Div_Property_Value_Input.setAttribute("data-PropertyName", stream_Prop_Name)
                  let update_Property_Value = (event) => {
                      let new_Value = event.target.value
                      let prop_Name = event.target.getAttribute("data-PropertyName")
                      let stream_Id = event.target.id.replace('Value_Input', '')
                      stream_Id.replace(prop_Name, '')
                      graph.getCell(stream_Id).prop({ 'stream_Properties': { prop_Name: { 'Value': new_Value } } })
                  }
                  next_Stream_Div_Property_Value_Input.addEventListener("change", update_Property_Value)

                  let next_Stream_Div_Property_Units_Input = document.createElement("input")
                  next_Stream_Div_Property_Units_Input.classList.add('stream-property-input')
                  stream_Div_Section_2.appendChild(next_Stream_Div_Property_Units_Input)
                  next_Stream_Div_Property_Units_Input.setAttribute('placeholder', 'Units')
                  next_Stream_Div_Property_Units_Input.value = stream_Prop_Units
                  next_Stream_Div_Property_Units_Input.id = link_Id + stream_Prop_Name + 'Units_Input'
                  next_Stream_Div_Property_Units_Input.setAttribute("data-PropertyName", stream_Prop_Name)
                  let update_Property_Units = (event) => {
                      let new_Units = event.target.value
                      let prop_Name = event.target.getAttribute("data-PropertyName")
                      let stream_Id = event.target.id.replace('Units_Input', '')
                      stream_Id.replace(prop_Name, '')
                      graph.getCell(stream_Id).prop({ 'stream_Properties': { prop_Name: { 'Units': new_Units } } })
                  }
                  next_Stream_Div_Property_Units_Input.addEventListener("change", update_Property_Units)

                  let next_Stream_Div_Property_Remove_Button = document.createElement("BUTTON")
                  next_Stream_Div_Property_Remove_Button.classList.add('stream-property-button')
                  stream_Div_Section_2.appendChild(next_Stream_Div_Property_Remove_Button)
                  next_Stream_Div_Property_Remove_Button.textContent = ' X '
                  next_Stream_Div_Property_Remove_Button.style.color = 'red'
                  next_Stream_Div_Property_Remove_Button.id = link_Id + 'Remove_Button' + stream_Prop_Name
                  let stream_Property_Removed = (event) => {
                      //
                      let stream_Property_Identifier = event.target.id.replace('Remove_Button', '')
                      let Property_Name = event.target.id.slice(event.target.id.indexOf('Remove_Button') + 13)
                      document.getElementById(stream_Property_Identifier + 'Label_Input').remove()
                      document.getElementById(stream_Property_Identifier + 'Value_Input').remove()
                      document.getElementById(stream_Property_Identifier + 'Units_Input').remove()
                      event.target.remove()
                      delete stream.attributes['stream_Properties'][Property_Name]
                  }
                  next_Stream_Div_Property_Remove_Button.addEventListener("click", stream_Property_Removed)

              }
          }
          catch (e) {
              if (e instanceof TypeError) {
                  //
              }
          }

      }

  }

  equipment_Property_Popup(element_Id) {
      var graph = this.graph
      var paper = this.paper
      let equipment = graph.getCell(element_Id);
      let element_View = paper.findViewByModel(equipment);
      let label_Text = "Unit Components";
      let targ = paper.$el.offset();
      this.displayEquipmentPropPopup(element_Id,equipment,element_View,label_Text, targ)
  }

  connect_Pipework_Shape(link) {
      commandManager.initBatchCommand()
      let original_Number = 'No Label Required'
      if (link.label(0)) {
          original_Number = link.label(0).attrs.labelInputDiv.value
      }
      var paper_Point = paper.pageToLocalPoint({ x: link.prop('mouse_Enter_Entry_Point').x, y: link.prop('mouse_Enter_Entry_Point').y })
      var linkView = paper.findViewByModel(link)
      var closest_Point = linkView.getClosestPoint(paper_Point)
      var s = new joint.shapes.pipework.MixerSplitterObject()
      s.prop('unitType', 'pipework');
      let center_Point = closest_Point;
      let existing_Link_Source_Id = link.source().id
      let existing_Link_Source_Port = link.source().port
      var existing_Link_Source_Object = {
          id: existing_Link_Source_Id, port: existing_Link_Source_Port
      };
      if (graph.getCell(link.source().id).prop('unitType') == 'pipework') {
          existing_Link_Source_Object = {
              id: existing_Link_Source_Id, port: existing_Link_Source_Port,
              anchor: {
                  name: 'center'
              }
          };
      }
      let existing_Link_Target_Id = link.target().id
      if (existing_Link_Target_Id == undefined) {
          existing_Link_Target_Object = link.getTargetPoint()
      }
      else {
          let existing_Link_Target_Port = link.target().port
          var existing_Link_Target_Object = {
              id: existing_Link_Target_Id, port: existing_Link_Target_Port
          };
          if (graph.getCell(link.source().id).prop('unitType') == 'pipework') {
              existing_Link_Target_Object = {
                  id: existing_Link_Target_Id, port: existing_Link_Target_Port,
                  anchor: {
                      name: 'center'
                  }
              };
          }
      }

      let top_Center_Point = { x: center_Point.x, y: center_Point.y - 1 }
      let bottom_Center_Point = { x: center_Point.x, y: center_Point.y + 1 }
      let left_Center_Point = { x: center_Point.x - 1, y: center_Point.y }
      let right_Center_Point = { x: center_Point.x + 1, y: center_Point.y }
      // I think we should extend this search radius to 25, so that you can insert a 30px shape with 10px padding room that wont disturb any bends
      //center_Point.x = parseInt(center_Point.x, 10)
      //center_Point.y = parseInt(center_Point.y, 10)

      top_Point_Distance = Math.abs(linkView.getClosestPoint(top_Center_Point).y - top_Center_Point.y)
      bottom_Point_Distance = Math.abs(linkView.getClosestPoint(bottom_Center_Point).y - bottom_Center_Point.y)
      left_Point_Distance = Math.abs(linkView.getClosestPoint(left_Center_Point).x - left_Center_Point.x)
      right_Point_Distance = Math.abs(linkView.getClosestPoint(right_Center_Point).x - right_Center_Point.x)

      // Find the two shortest distances
      let min_Value = Math.min(top_Point_Distance, bottom_Point_Distance, left_Point_Distance, right_Point_Distance)
      var new_Link_From_Splitter, new_Link_To_Splitter

      if (top_Point_Distance == min_Value) {
          let second_Min_Value = Math.min(bottom_Point_Distance, left_Point_Distance, right_Point_Distance)
          if (bottom_Point_Distance == second_Min_Value) {
              // TOP AND BOTTOM
              s.attr('body/stroke', 'none');
              s.attr('topline/stroke', 'black');
              s.attr('bottomline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(bottom_Center_Point) <= linkView.getClosestPointRatio(top_Center_Point)) {
                  // Connect in to bottom and out from top
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15)
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['bottom'] })
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_bottom_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] })
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_top_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter)
              }
              else {
                  // Connect into top and out of bottom
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15)
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['top'] })
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_top_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] })
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_bottom_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter)
              }
          }
          else if (left_Point_Distance == second_Min_Value) {
              // TOP AND LEFT
              s.attr('body/stroke', 'none');
              s.attr('topline/stroke', 'black');
              s.attr('leftline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(left_Center_Point) <= linkView.getClosestPointRatio(top_Center_Point)) {
                  // Connect in to left and out from top
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');

                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['left'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_left_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_top_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
              else {
                  // Connect into top and out of left
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15)
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['top'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_top_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_left_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
          }
          else {
              // TOP AND RIGHT
              s.attr('body/stroke', 'none');
              s.attr('topline/stroke', 'black');
              s.attr('rightline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(right_Center_Point) <= linkView.getClosestPointRatio(top_Center_Point)) {
                  // Connect in to right and out from top
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15)
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['right'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_right_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_top_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
              else {
                  // Connect into top and out of right
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15)
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_top_1' });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['top'] });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_right_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter)
              }
          }
      }
      else if (bottom_Point_Distance == min_Value) {
          let second_Min_Value = Math.min(top_Point_Distance, left_Point_Distance, right_Point_Distance)
          if (top_Point_Distance == second_Min_Value) {
              // BOTTOM AND TOP
              s.attr('body/stroke', 'none');
              s.attr('topline/stroke', 'black');
              s.attr('bottomline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(bottom_Center_Point) <= linkView.getClosestPointRatio(top_Center_Point)) {
                  // Connect in to bottom and out from top
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');

                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['bottom'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_bottom_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_top_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
              else {
                  // Connect into top and out of bottom
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['top'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_top_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_bottom_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
          }
          else if (left_Point_Distance == second_Min_Value) {
              // BOTTOM AND LEFT
              s.attr('body/stroke', 'none');
              s.attr('bottomline/stroke', 'black');
              s.attr('leftline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(left_Center_Point) <= linkView.getClosestPointRatio(bottom_Center_Point)) {
                  // Connect in to left and out from bottom
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['left'] })
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_left_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] })
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_bottom_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
              else {
                  // Connect into bottom and out of left
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['bottom'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_bottom_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] })
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_left_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
          }
          else {
              // BOTTOM AND RIGHT
              s.attr('body/stroke', 'none');
              s.attr('bottomline/stroke', 'black');
              s.attr('rightline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(right_Center_Point) <= linkView.getClosestPointRatio(bottom_Center_Point)) {
                  // Connect in to right and out from bottom
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');

                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['right'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_right_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_bottom_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
              else {
                  // Connect into bottom and out of right
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['bottom'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_bottom_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_right_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
          }
      }
      else if (left_Point_Distance == min_Value) {
          let second_Min_Value = Math.min(top_Point_Distance, bottom_Point_Distance, right_Point_Distance)
          if (top_Point_Distance == second_Min_Value) {
              // LEFT AND TOP
              s.attr('body/stroke', 'none');
              s.attr('topline/stroke', 'black');
              s.attr('leftline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(left_Center_Point) <= linkView.getClosestPointRatio(top_Center_Point)) {
                  // Connect in to left and out from top
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['left'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_left_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] })
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_top_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
              else {
                  // Connect into top and out of left
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['top'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_top_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_left_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
          }
          else if (bottom_Point_Distance == second_Min_Value) {
              // BOTTOM AND LEFT
              s.attr('body/stroke', 'none');
              s.attr('bottomline/stroke', 'black');
              s.attr('leftline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(left_Center_Point) <= linkView.getClosestPointRatio(bottom_Center_Point)) {
                  // Connect in to left and out from bottom
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['left'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_left_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_bottom_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
              else {
                  // Connect into bottom and out of left
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['bottom'] })
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_bottom_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_left_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
          }
          else {
              // LEFT AND RIGHT
              s.attr('body/stroke', 'none');
              s.attr('leftline/stroke', 'black');
              s.attr('rightline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(right_Center_Point) <= linkView.getClosestPointRatio(left_Center_Point)) {
                  // Connect in to right and out from left
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['right'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_right_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_left_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
              else {
                  // Connect into left and out of right
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['left'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_left_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_right_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
          }
      }
      else {
          // RIGHT and others
          let second_Min_Value = Math.min(top_Point_Distance, bottom_Point_Distance, left_Point_Distance)
          if (top_Point_Distance == second_Min_Value) {
              // RIGHT AND TOP
              s.attr('body/stroke', 'none');
              s.attr('topline/stroke', 'black');
              s.attr('rightline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(right_Center_Point) <= linkView.getClosestPointRatio(top_Center_Point)) {
                  // Connect in to right and out from top
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['right'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_right_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_top_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
              else {
                  // Connect into top and out of right
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['top'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_top_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_right_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
          }
          else if (bottom_Point_Distance == second_Min_Value) {
              // BOTTOM AND right
              s.attr('body/stroke', 'none');
              s.attr('bottomline/stroke', 'black');
              s.attr('rightline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(right_Center_Point) <= linkView.getClosestPointRatio(bottom_Center_Point)) {
                  // Connect in to right and out from bottom
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['right'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_right_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_bottom_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
              else {
                  // Connect into bottom and out of right
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15)
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['bottom'] })
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_bottom_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] })
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_right_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter)
              }
          }
          else {
              // LEFT AND RIGHT
              s.attr('body/stroke', 'none');
              s.attr('leftline/stroke', 'black');
              s.attr('rightline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(right_Center_Point) <= linkView.getClosestPointRatio(left_Center_Point)) {
                  // Connect in to right and out from left
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  s.resize(30, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y - 15);
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['right'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_right_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] })
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_left_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter)
              }
              else {
                  // Connect into left and out of right
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 30);
                  s.position(center_Point.x - 15, center_Point.y - 15)
                  new_Link_To_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['left'] });
                  new_Link_To_Splitter.source(existing_Link_Source_Object);
                  new_Link_To_Splitter.target({ id: s.id, port: 'in_left_1' });

                  new_Link_From_Splitter = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] });
                  new_Link_From_Splitter.source({ id: s.id, port: 'out_right_1' });
                  new_Link_From_Splitter.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Splitter, new_Link_From_Splitter);
              }
          }
      }
      if (original_Number == '') {
          new_Link_To_Splitter.label(0, { attrs: { 'labelInputDiv': { style: { borderBottom: 'hidden' } } } });
          new_Link_To_Splitter.label(0, { attrs: { 'labelInputDiv': { style: { borderTop: 'hidden' } } } });
          new_Link_To_Splitter.label(0, { attrs: { 'labelInputDiv': { style: { borderLeft: 'hidden' } } } });
          new_Link_To_Splitter.label(0, { attrs: { 'labelInputDiv': { style: { borderRight: 'hidden' } } } });
          new_Link_To_Splitter.label(0, { attrs: { 'labelInputDiv': { style: { backgroundColor: 'transparent' } } } });
      }
      new_Link_To_Splitter.label(0, { attrs: { 'labelInputDiv': { value: original_Number } } });
      this.stream_Count = this.stream_Count - 1
      //stream_Number_Div.value = stream_Count;
      new_Link_From_Splitter.label(0, { attrs: { 'labelInputDiv': { value: this.stream_Count - 1 } } });
      new_Link_To_Splitter.prop('CustomName', original_Number)
      new_Link_From_Splitter.prop('CustomName', this.stream_Count - 1)

      new_Link_To_Splitter.router('manhattan', {
          startDirections: [new_Link_To_Splitter.source().port.split('_')[1]],
          endDirections: [new_Link_To_Splitter.target().port.split('_')[1]],
          padding: 10, step: 10
      })
      new_Link_From_Splitter.router('manhattan', {
          startDirections: [new_Link_From_Splitter.source().port.split('_')[1]],
          endDirections: [new_Link_From_Splitter.target().port.split('_')[1]],
          padding: 10, step: 10
      })



      let new_LinkView1 = paper.findViewByModel(new_Link_To_Splitter)
      //Add vertices to the turning points
      let new_link1_Svg_String = new_LinkView1.getSerializedConnection();
      new_link1_Svg_String = new_link1_Svg_String.replace('M ', '');

      let source_Point1 = new_LinkView1.model.getSourcePoint();
      let target_Point1 = new_LinkView1.model.getTargetPoint();

      new_link1_Path_Array = new_link1_Svg_String.split(" L ");
      let link1_Coordinates = [];
      for (let i = 0; i < new_link1_Path_Array.length; i++) {
          link1_Coordinates.push(new_link1_Path_Array[i].split(" "))
      }
      for (let i = 0; i < link1_Coordinates.length; i++) {
          let vertex1 = { x: link1_Coordinates[i][0], y: link1_Coordinates[i][1] }
          if (!(((Math.abs(source_Point1.x - vertex1.x) < 5) && (Math.abs(source_Point1.y - vertex1.y) < 5)) || ((Math.abs(target_Point1.x - vertex1.x) < 5) && (Math.abs(target_Point1.y - vertex1.y) < 5)))) {
              new_LinkView1.addVertex(parseInt(vertex1.x, 10), parseInt(vertex1.y, 10))
          }
      }
      new_LinkView1.removeRedundantLinearVertices()


      let new_LinkView2 = paper.findViewByModel(new_Link_From_Splitter)
      //Add vertices to the turning points
      let new_link2_Svg_String = new_LinkView2.getSerializedConnection();
      new_link2_Svg_String = new_link2_Svg_String.replace('M ', '');

      let source_Point2 = new_LinkView2.model.getSourcePoint();
      let target_Point2 = new_LinkView2.model.getTargetPoint();

      new_link2_Path_Array = new_link2_Svg_String.split(" L ");
      let link2_Coordinates = [];
      for (let i = 0; i < new_link2_Path_Array.length; i++) {
          link2_Coordinates.push(new_link2_Path_Array[i].split(" "))
      }
      for (let i = 0; i < link2_Coordinates.length; i++) {
          let vertex2 = { x: link2_Coordinates[i][0], y: link2_Coordinates[i][1] }
          if (!(((Math.abs(source_Point2.x - vertex2.x) < 5) && (Math.abs(source_Point2.y - vertex2.y) < 5)) || ((Math.abs(target_Point2.x - vertex2.x) < 5) && (Math.abs(target_Point2.y - vertex2.y) < 5)))) {
              new_LinkView2.addVertex(parseInt(vertex2.x, 10), parseInt(vertex2.y, 10))
          }
      }
      new_LinkView2.removeRedundantLinearVertices()



      if ((new_Link_To_Splitter.source().id) && (graph.getCell(new_Link_To_Splitter.source().id).prop('unitType') == 'pipework')) {

          if (new_Link_To_Splitter.source().port == 'out_top_1') {
              graph.getCell(new_Link_To_Splitter.source().id).attr('topline/stroke', 'black')
              new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] })
          }
          if (new_Link_To_Splitter.source().port == 'out_bottom_1') {
              graph.getCell(new_Link_To_Splitter.source().id).attr('bottomline/stroke', 'black')
              new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] })
          }
          if (new_Link_To_Splitter.source().port == 'out_right_1') {
              graph.getCell(new_Link_To_Splitter.source().id).attr('rightline/stroke', 'black')
              new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] })

          }
          if (new_Link_To_Splitter.source().port == 'out_left_1') {
              graph.getCell(new_Link_To_Splitter.source().id).attr('leftline/stroke', 'black')
              new_Link_To_Splitter.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] })
          }
      }



      commandManager.storeBatchCommand()


  }

  connect_Valve_Shape(link) {
      commandManager.initBatchCommand()
      let original_Stream_Properties = 'No Properties Exist'
      if (link.attributes.stream_Properties) {
          original_Stream_Properties = link.attributes.stream_Properties
      }
      let original_Number = 'No Label Required'
      if (link.label(0)) {
          original_Number = link.label(0).attrs.labelInputDiv.value
      }
      var paper_Point = paper.pageToLocalPoint({ x: link.prop('mouse_Enter_Entry_Point').x, y: link.prop('mouse_Enter_Entry_Point').y })
      var linkView = paper.findViewByModel(link)
      var closest_Point = linkView.getClosestPoint(paper_Point)

      let center_Point = closest_Point;
      let existing_Link_Source_Id = link.source().id
      let existing_Link_Source_Port = link.source().port
      var existing_Link_Source_Object = {
          id: existing_Link_Source_Id, port: existing_Link_Source_Port
      };
      if (graph.getCell(link.source().id).prop('unitType') == 'pipework') {
          existing_Link_Source_Object = {
              id: existing_Link_Source_Id, port: existing_Link_Source_Port,
              anchor: {
                  name: 'center'
              }
          };
      }
      let existing_Link_Target_Id = link.target().id
      if (existing_Link_Target_Id == undefined) {
          existing_Link_Target_Object = link.getTargetPoint()
      }
      else {
          let existing_Link_Target_Port = link.target().port
          var existing_Link_Target_Object = {
              id: existing_Link_Target_Id, port: existing_Link_Target_Port
          };
          if (graph.getCell(link.source().id).prop('unitType') == 'pipework') {
              existing_Link_Target_Object = {
                  id: existing_Link_Target_Id, port: existing_Link_Target_Port,
                  anchor: {
                      name: 'center'
                  }
              };
          }
      }

      let top_Center_Point = { x: center_Point.x, y: center_Point.y - 1 }
      let bottom_Center_Point = { x: center_Point.x, y: center_Point.y + 1 }
      let left_Center_Point = { x: center_Point.x - 1, y: center_Point.y }
      let right_Center_Point = { x: center_Point.x + 1, y: center_Point.y }
      //center_Point.x = parseInt(center_Point.x, 10)
      //center_Point.y = parseInt(center_Point.y, 10)

      top_Point_Distance = Math.abs(linkView.getClosestPoint(top_Center_Point).y - top_Center_Point.y)
      bottom_Point_Distance = Math.abs(linkView.getClosestPoint(bottom_Center_Point).y - bottom_Center_Point.y)
      left_Point_Distance = Math.abs(linkView.getClosestPoint(left_Center_Point).x - left_Center_Point.x)
      right_Point_Distance = Math.abs(linkView.getClosestPoint(right_Center_Point).x - right_Center_Point.x)



      // Find the two shortest distances
      let min_Value = Math.min(top_Point_Distance, bottom_Point_Distance, left_Point_Distance, right_Point_Distance)
      var new_Link_From_Valve, new_Link_To_Valve

      if (top_Point_Distance == min_Value) {
          let second_Min_Value = Math.min(bottom_Point_Distance, left_Point_Distance, right_Point_Distance)
          if (bottom_Point_Distance == second_Min_Value) {
              // TOP AND BOTTOM
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(bottom_Center_Point) <= linkView.getClosestPointRatio(top_Center_Point)) {
                  // Connect in to bottom and out from top
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.VertValveObject()
                  s.prop('unitType', 'valve');
                  s.prop('isUnit', 'yes');
                  s.resize(19, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 6, center_Point.y - 15)
                  new_Link_To_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['bottom'] });
                  new_Link_To_Valve.source(existing_Link_Source_Object);
                  new_Link_To_Valve.target({
                      id: s.id, port: 'in_bottom_1',
                      anchor: {
                          name: 'center'
                      }
                  });

                  new_Link_From_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] });
                  new_Link_From_Valve.source({
                      id: s.id, port: 'out_top_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Valve, new_Link_From_Valve)
              }
              else {
                  // Connect into top and out of bottom
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.VertValveObject()
                  s.prop('unitType', 'valve');
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(19, 30);
                  s.position(center_Point.x - 6, center_Point.y - 15)
                  new_Link_To_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['top'] });
                  new_Link_To_Valve.source(existing_Link_Source_Object);
                  new_Link_To_Valve.target({
                      id: s.id, port: 'in_top_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });

                  new_Link_From_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] });
                  new_Link_From_Valve.source({
                      id: s.id, port: 'out_bottom_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Valve, new_Link_From_Valve)
              }
          }
          else if (left_Point_Distance == second_Min_Value) {
              // TOP AND LEFT
              alert('Please insert valve further away from bend');
          }
          else {
              // TOP AND RIGHT
              alert('Please insert valve further away from bend');
          }
      }
      else if (bottom_Point_Distance == min_Value) {
          let second_Min_Value = Math.min(top_Point_Distance, left_Point_Distance, right_Point_Distance)
          if (top_Point_Distance == second_Min_Value) {
              // BOTTOM AND TOP
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(bottom_Center_Point) <= linkView.getClosestPointRatio(top_Center_Point)) {
                  // Connect in to bottom and out from top
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.VertValveObject()
                  s.prop('unitType', 'valve');
                  s.prop('isUnit', 'yes');
                  s.resize(19, 30);
                  graph.addCell(s);
                  s.position(center_Point.x - 6, center_Point.y - 15)
                  new_Link_To_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['bottom'] });
                  new_Link_To_Valve.source(existing_Link_Source_Object);
                  new_Link_To_Valve.target({
                      id: s.id, port: 'in_bottom_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });

                  new_Link_From_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] });
                  new_Link_From_Valve.source({
                      id: s.id, port: 'out_top_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Valve, new_Link_From_Valve)
              }
              else {
                  // Connect into top and out of bottom
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.VertValveObject()
                  s.prop('unitType', 'valve');
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(19, 30);
                  s.position(center_Point.x - 6, center_Point.y - 15)
                  new_Link_To_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['top'] });
                  new_Link_To_Valve.source(existing_Link_Source_Object);
                  new_Link_To_Valve.target({
                      id: s.id, port: 'in_top_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });

                  new_Link_From_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] })
                  new_Link_From_Valve.source({
                      id: s.id, port: 'out_bottom_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Valve, new_Link_From_Valve)
              }
          }
          else if (left_Point_Distance == second_Min_Value) {
              // BOTTOM AND LEFT
              alert('Please insert valve further away from bend');
          }
          else {
              // BOTTOM AND RIGHT
              alert('Please insert valve further away from bend');
          }
      }
      else if (left_Point_Distance == min_Value) {
          let second_Min_Value = Math.min(top_Point_Distance, bottom_Point_Distance, right_Point_Distance)
          if (top_Point_Distance == second_Min_Value) {
              // LEFT AND TOP
              alert('Please insert valve further away from bend');
          }
          else if (bottom_Point_Distance == second_Min_Value) {
              // BOTTOM AND LEFT
              alert('Please insert valve further away from bend');
          }
          else {
              // LEFT AND RIGHT
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(right_Center_Point) <= linkView.getClosestPointRatio(left_Center_Point)) {
                  // Connect in to right and out from left
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.HorizValveObject()
                  s.prop('unitType', 'valve');
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 19);
                  s.position(center_Point.x - 15, center_Point.y - 13)
                  new_Link_To_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['right'] });
                  new_Link_To_Valve.source(existing_Link_Source_Object);
                  new_Link_To_Valve.target({
                      id: s.id, port: 'in_right_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] });
                  new_Link_From_Valve.source({
                      id: s.id, port: 'out_left_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Valve, new_Link_From_Valve)
              }
              else {
                  // Connect into left and out of right
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.HorizValveObject()
                  s.prop('unitType', 'valve');
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 19);
                  s.position(center_Point.x - 15, center_Point.y - 13)
                  new_Link_To_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['left'] });
                  new_Link_To_Valve.source(existing_Link_Source_Object);
                  new_Link_To_Valve.target({
                      id: s.id, port: 'in_left_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] });
                  new_Link_From_Valve.source({
                      id: s.id, port: 'out_right_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Valve, new_Link_From_Valve)
              }
          }
      }
      else {
          // RIGHT and others
          let second_Min_Value = Math.min(top_Point_Distance, bottom_Point_Distance, left_Point_Distance)
          if (top_Point_Distance == second_Min_Value) {
              // RIGHT AND TOP
              alert('Please insert valve further away from bend');
          }
          else if (bottom_Point_Distance == second_Min_Value) {
              // BOTTOM AND right
              alert('Please insert valve further away from bend');
          }
          else {
              // LEFT AND RIGHT
              s.attr('leftline/stroke', 'black');
              s.attr('rightline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(right_Center_Point) <= linkView.getClosestPointRatio(left_Center_Point)) {
                  // Connect in to right and out from left
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.HorizValveObject()
                  s.prop('unitType', 'valve');
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 19);
                  s.position(center_Point.x - 15, center_Point.y - 13)
                  new_Link_To_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['right'] });
                  new_Link_To_Valve.source(existing_Link_Source_Object);
                  new_Link_To_Valve.target({
                      id: s.id, port: 'in_right_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_From_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] });
                  new_Link_From_Valve.source({
                      id: s.id, port: 'out_left_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Valve, new_Link_From_Valve)
              }
              else {
                  // Connect into left and out of right
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.HorizValveObject()
                  s.prop('unitType', 'valve');
                  s.prop('isUnit', 'yes');
                  graph.addCell(s);
                  s.resize(30, 19);
                  s.position(center_Point.x - 15, center_Point.y - 13)
                  new_Link_To_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['left'] })
                  new_Link_To_Valve.source(existing_Link_Source_Object);
                  new_Link_To_Valve.target({
                      id: s.id, port: 'in_left_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } }, });
                  //new_Link_From_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] })
                  new_Link_From_Valve.source({
                      id: s.id, port: 'out_right_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_Valve.target(existing_Link_Target_Object);
                  graph.addCells(new_Link_To_Valve, new_Link_From_Valve)
              }
          }
      }
      if (original_Number == '') {
          new_Link_To_Valve.label(0, { attrs: { 'labelInputDiv': { style: { borderBottom: 'hidden' } } } });
          new_Link_To_Valve.label(0, { attrs: { 'labelInputDiv': { style: { borderTop: 'hidden' } } } });
          new_Link_To_Valve.label(0, { attrs: { 'labelInputDiv': { style: { borderLeft: 'hidden' } } } });
          new_Link_To_Valve.label(0, { attrs: { 'labelInputDiv': { style: { borderRight: 'hidden' } } } });
          new_Link_To_Valve.label(0, { attrs: { 'labelInputDiv': { style: { backgroundColor: 'transparent' } } } });
      }
      new_Link_To_Valve.label(0, { attrs: { 'labelInputDiv': { value: original_Number } } });
      this.stream_Count = this.stream_Count - 1
      //stream_Number_Div.value = stream_Count;
      new_Link_From_Valve.label(0, { attrs: { 'labelInputDiv': { value: this.stream_Count - 1 } } });
      new_Link_To_Valve.prop('CustomName', original_Number)

      new_Link_To_Valve.router('manhattan', {
          startDirections: [new_Link_To_Valve.source().port.split('_')[1]],
          endDirections: [new_Link_To_Valve.target().port.split('_')[1]],
          padding: 10, step: 10
      })
      new_Link_From_Valve.router('manhattan', {
          startDirections: [new_Link_From_Valve.source().port.split('_')[1]],
          endDirections: [new_Link_From_Valve.target().port.split('_')[1]],
          padding: 10, step: 10
      })

      if (original_Stream_Properties != 'No Properties Exist') {
          new_Link_To_Valve.prop({ 'stream_Properties': original_Stream_Properties })
          new_Link_From_Valve.prop({ 'stream_Properties': original_Stream_Properties })
      }

      new_Link_From_Valve.label(0, { attrs: { 'labelInputDiv': { value: '' } } });
      new_Link_From_Valve.prop('CustomName', '')
      new_Link_From_Valve.label(0, { attrs: { 'labelInputDiv': { style: { borderBottom: 'hidden' } } } });
      new_Link_From_Valve.label(0, { attrs: { 'labelInputDiv': { style: { borderTop: 'hidden' } } } });
      new_Link_From_Valve.label(0, { attrs: { 'labelInputDiv': { style: { borderLeft: 'hidden' } } } });
      new_Link_From_Valve.label(0, { attrs: { 'labelInputDiv': { style: { borderRight: 'hidden' } } } });
      new_Link_From_Valve.label(0, { attrs: { 'labelInputDiv': { style: { backgroundColor: 'transparent' } } } });

      let new_LinkView1 = paper.findViewByModel(new_Link_To_Valve)
      //Add vertices to the turning points
      let new_link1_Svg_String = new_LinkView1.getSerializedConnection();
      new_link1_Svg_String = new_link1_Svg_String.replace('M ', '');

      let source_Point1 = new_LinkView1.model.getSourcePoint();
      let target_Point1 = new_LinkView1.model.getTargetPoint();

      new_link1_Path_Array = new_link1_Svg_String.split(" L ");
      let link1_Coordinates = [];
      for (let i = 0; i < new_link1_Path_Array.length; i++) {
          link1_Coordinates.push(new_link1_Path_Array[i].split(" "))
      }
      for (let i = 0; i < link1_Coordinates.length; i++) {
          let vertex1 = { x: link1_Coordinates[i][0], y: link1_Coordinates[i][1] }
          if (!(((Math.abs(source_Point1.x - vertex1.x) < 5) && (Math.abs(source_Point1.y - vertex1.y) < 5)) || ((Math.abs(target_Point1.x - vertex1.x) < 5) && (Math.abs(target_Point1.y - vertex1.y) < 5)))) {
              new_LinkView1.addVertex(parseInt(vertex1.x, 10), parseInt(vertex1.y, 10))
          }
      }
      new_LinkView1.removeRedundantLinearVertices()
      let new_LinkView2 = paper.findViewByModel(new_Link_From_Valve)
      //Add vertices to the turning points
      let new_link2_Svg_String = new_LinkView2.getSerializedConnection();
      new_link2_Svg_String = new_link2_Svg_String.replace('M ', '');

      let source_Point2 = new_LinkView2.model.getSourcePoint();
      let target_Point2 = new_LinkView2.model.getTargetPoint();

      new_link2_Path_Array = new_link2_Svg_String.split(" L ");
      let link2_Coordinates = [];
      for (let i = 0; i < new_link2_Path_Array.length; i++) {
          link2_Coordinates.push(new_link2_Path_Array[i].split(" "))
      }
      for (let i = 0; i < link2_Coordinates.length; i++) {
          let vertex2 = { x: link2_Coordinates[i][0], y: link2_Coordinates[i][1] }
          if (!(((Math.abs(source_Point2.x - vertex2.x) < 5) && (Math.abs(source_Point2.y - vertex2.y) < 5)) || ((Math.abs(target_Point2.x - vertex2.x) < 5) && (Math.abs(target_Point2.y - vertex2.y) < 5)))) {
              new_LinkView2.addVertex(parseInt(vertex2.x, 10), parseInt(vertex2.y, 10))
          }
      }
      new_LinkView2.removeRedundantLinearVertices()

      if ((new_Link_To_Valve.source().id) && (graph.getCell(new_Link_To_Valve.source().id).prop('unitType') == 'pipework')) {

          if (new_Link_To_Valve.source().port == 'out_top_1') {
              graph.getCell(new_Link_To_Valve.source().id).attr('topline/stroke', 'black')
              new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] })
          }
          if (new_Link_To_Valve.source().port == 'out_bottom_1') {
              graph.getCell(new_Link_To_Valve.source().id).attr('bottomline/stroke', 'black')
              new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] })
          }
          if (new_Link_To_Valve.source().port == 'out_right_1') {
              graph.getCell(new_Link_To_Valve.source().id).attr('rightline/stroke', 'black')
              new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] })
          }
          if (new_Link_To_Valve.source().port == 'out_left_1') {
              graph.getCell(new_Link_To_Valve.source().id).attr('leftline/stroke', 'black')
              new_Link_To_Valve.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] })
          }
      }

      if ((new_Link_From_Valve.target().id) && ((graph.getCell(new_Link_From_Valve.target().id).prop('unitType') == 'SensorConnector') || (graph.getCell(new_Link_From_Valve.target().id).prop('unitType') == 'valve'))) {
          new_Link_From_Valve.attr('line/targetMarker/d', 'M 0 0')
      }

      new_Link_To_Valve.attr('line/targetMarker/d', 'M 0 0')

      commandManager.storeBatchCommand()

  }
  connect_Sensor_Shape(link) {
      commandManager.initBatchCommand()

      //
      let original_Stream_Properties = 'No Properties Exist'
      if (link.attributes.stream_Properties) {
          original_Stream_Properties = link.attributes.stream_Properties
      }
      let original_Number = 'No Label Required'
      if (link.label(0)) {
          original_Number = link.label(0).attrs.labelInputDiv.value
      }
      var paper_Point = paper.pageToLocalPoint({ x: link.prop('mouse_Enter_Entry_Point').x, y: link.prop('mouse_Enter_Entry_Point').y })
      var linkView = paper.findViewByModel(link)
      var closest_Point = linkView.getClosestPoint(paper_Point)

      let center_Point = closest_Point;
      let existing_Link_Source_Id = link.source().id
      let existing_Link_Source_Port = link.source().port
      var existing_Link_Source_Object = {
          id: existing_Link_Source_Id, port: existing_Link_Source_Port
      };
      if (graph.getCell(link.source().id).prop('unitType') == 'pipework') {
          existing_Link_Source_Object = {
              id: existing_Link_Source_Id, port: existing_Link_Source_Port,
              anchor: {
                  name: 'center'
              }
          };
      }
      let existing_Link_Target_Id = link.target().id
      if (existing_Link_Target_Id == undefined) {
          existing_Link_Target_Object = link.getTargetPoint()
      }
      else {
          let existing_Link_Target_Port = link.target().port
          var existing_Link_Target_Object = {
              id: existing_Link_Target_Id, port: existing_Link_Target_Port
          };
          if (graph.getCell(link.source().id).prop('unitType') == 'pipework') {
              existing_Link_Target_Object = {
                  id: existing_Link_Target_Id, port: existing_Link_Target_Port,
                  anchor: {
                      name: 'center'
                  }
              };
          }
      }

      let top_Center_Point = { x: center_Point.x, y: center_Point.y - 1 }
      let bottom_Center_Point = { x: center_Point.x, y: center_Point.y + 1 }
      let left_Center_Point = { x: center_Point.x - 1, y: center_Point.y }
      let right_Center_Point = { x: center_Point.x + 1, y: center_Point.y }
      //center_Point.x = parseInt(center_Point.x, 10)
      //center_Point.y = parseInt(center_Point.y, 10)

      top_Point_Distance = Math.abs(linkView.getClosestPoint(top_Center_Point).y - top_Center_Point.y)
      bottom_Point_Distance = Math.abs(linkView.getClosestPoint(bottom_Center_Point).y - bottom_Center_Point.y)
      left_Point_Distance = Math.abs(linkView.getClosestPoint(left_Center_Point).x - left_Center_Point.x)
      right_Point_Distance = Math.abs(linkView.getClosestPoint(right_Center_Point).x - right_Center_Point.x)

      // Find the two shortest distances
      let min_Value = Math.min(top_Point_Distance, bottom_Point_Distance, left_Point_Distance, right_Point_Distance)
      var new_Link_From_SensorConnector, new_Link_To_SensorConnector

      if (top_Point_Distance == min_Value) {
          let second_Min_Value = Math.min(bottom_Point_Distance, left_Point_Distance, right_Point_Distance)
          if (bottom_Point_Distance == second_Min_Value) {
              // TOP AND BOTTOM
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(bottom_Center_Point) <= linkView.getClosestPointRatio(top_Center_Point)) {
                  // Connect in to bottom and out from top
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.SensorConnectorVertObject()
                  s.prop('unitType', 'SensorConnector');
                  s.prop('isUnit', 'yes');
                  s.resize(1, 30);
                  graph.addCell(s);
                  s.position(center_Point.x, center_Point.y - 15)
                  new_Link_To_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['bottom'] })
                  new_Link_To_SensorConnector.source(existing_Link_Source_Object);
                  new_Link_To_SensorConnector.target({
                      id: s.id, port: 'in_bottom_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_To_SensorConnector.attr('line/targetMarker/d', 'M 0 0')

                  new_Link_From_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] })
                  new_Link_From_SensorConnector.source({
                      id: s.id, port: 'out_top_1',
                      //anchor: {
                      //   name: 'center'
                      //}
                  });
                  new_Link_From_SensorConnector.target(existing_Link_Target_Object);

                  var si = new joint.shapes.pid.TPObject()
                  si.prop('unitType', 'Sensor');
                  si.resize(30, 30);
                  si.position(center_Point.x - 80, center_Point.y + -16)
                  graph.addCell(si)
                  new_Link_To_Sensor = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_To_Sensor.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'], endDirections: ['right'] });
                  new_Link_To_Sensor.source({ id: s.id, port: 'out_left_1' })
                  new_Link_To_Sensor.target({ id: si.id, port: 'in_right_1' })
                  graph.addCells(new_Link_To_SensorConnector, new_Link_From_SensorConnector, new_Link_To_Sensor)
                  new_Link_To_Sensor.attr('line/targetMarker/d', 'M 0 0')
                  new_Link_To_Sensor.removeLabel(-1)
              }
              else {
                  // Connect into top and out of bottom
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.SensorConnectorVertObject()
                  s.prop('unitType', 'SensorConnector');
                  s.prop('isUnit', 'yes');
                  s.resize(1, 30);
                  graph.addCell(s);
                  s.position(center_Point.x, center_Point.y - 15)
                  new_Link_To_SensorConnector = new joint.shapes.standard.Link({
                      attrs: {
                          line: { stroke: 'black', strokeWidth: 1 },
                      }
                  })
                  //new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['top'] });
                  new_Link_To_SensorConnector.source(existing_Link_Source_Object);
                  new_Link_To_SensorConnector.target({
                      id: s.id, port: 'in_top_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_To_SensorConnector.attr('line/targetMarker/d', 'M 0 0')

                  new_Link_From_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] });
                  new_Link_From_SensorConnector.source({
                      id: s.id, port: 'out_bottom_1',
                      //anchor: {
                      //   name: 'center'
                      //}
                  });
                  new_Link_From_SensorConnector.target(existing_Link_Target_Object);

                  var si = new joint.shapes.pid.TPObject()
                  si.prop('unitType', 'Sensor');
                  si.resize(30, 30);
                  si.position(center_Point.x - 80, center_Point.y - 16)
                  graph.addCell(si)
                  new_Link_To_Sensor = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_To_Sensor.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'], endDirections: ['right'] });
                  new_Link_To_Sensor.source({ id: s.id, port: 'out_left_1' });
                  new_Link_To_Sensor.target({ id: si.id, port: 'in_right_1' });
                  graph.addCells(new_Link_To_SensorConnector, new_Link_From_SensorConnector, new_Link_To_Sensor);
                  new_Link_To_Sensor.attr('line/targetMarker/d', 'M 0 0')
                  new_Link_To_Sensor.removeLabel(-1);
              }
          }
          else if (left_Point_Distance == second_Min_Value) {
              // TOP AND LEFT
              alert('Please insert SensorConnector further away from bend');
          }
          else {
              // TOP AND RIGHT
              alert('Please insert SensorConnector further away from bend');
          }
      }
      else if (bottom_Point_Distance == min_Value) {
          let second_Min_Value = Math.min(top_Point_Distance, left_Point_Distance, right_Point_Distance)
          if (top_Point_Distance == second_Min_Value) {
              // BOTTOM AND TOP
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(bottom_Center_Point) <= linkView.getClosestPointRatio(top_Center_Point)) {
                  // Connect in to bottom and out from top
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.SensorConnectorVertObject()
                  s.prop('unitType', 'SensorConnector');
                  s.prop('isUnit', 'yes');
                  s.resize(1, 30);
                  graph.addCell(s);
                  s.position(center_Point.x, center_Point.y - 15)
                  new_Link_To_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['bottom'] })
                  new_Link_To_SensorConnector.source(existing_Link_Source_Object);
                  new_Link_To_SensorConnector.target({
                      id: s.id, port: 'in_bottom_1',
                      // anchor: {
                      //    name: 'center'
                      // }
                  });
                  new_Link_To_SensorConnector.attr('line/targetMarker/d', 'M 0 0')

                  new_Link_From_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] })
                  new_Link_From_SensorConnector.source({
                      id: s.id, port: 'out_top_1',
                      //anchor: {
                      //   name: 'center'
                      //}
                  });
                  new_Link_From_SensorConnector.target(existing_Link_Target_Object);
                  var si = new joint.shapes.pid.TPObject()
                  si.prop('unitType', 'Sensor');
                  si.resize(30, 30);
                  si.position(center_Point.x - 80, center_Point.y - 16)
                  graph.addCell(si)
                  new_Link_To_Sensor = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_To_Sensor.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'], endDirections: ['right'] });
                  new_Link_To_Sensor.source({ id: s.id, port: 'out_left_1' })
                  new_Link_To_Sensor.target({ id: si.id, port: 'in_right_1' })
                  graph.addCells(new_Link_To_SensorConnector, new_Link_From_SensorConnector, new_Link_To_Sensor)
                  new_Link_To_Sensor.attr('line/targetMarker/d', 'M 0 0')
                  new_Link_To_Sensor.removeLabel(-1)
              }
              else {
                  // Connect into top and out of bottom
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.SensorConnectorVertObject()
                  s.prop('unitType', 'SensorConnector');
                  s.prop('isUnit', 'yes');
                  s.resize(1, 30);
                  graph.addCell(s);
                  s.position(center_Point.x, center_Point.y - 15)
                  new_Link_To_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['top'] })
                  new_Link_To_SensorConnector.source(existing_Link_Source_Object);
                  new_Link_To_SensorConnector.target({
                      id: s.id, port: 'in_top_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_To_SensorConnector.attr('line/targetMarker/d', 'M 0 0')

                  new_Link_From_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] })
                  new_Link_From_SensorConnector.source({
                      id: s.id, port: 'out_bottom_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_SensorConnector.target(existing_Link_Target_Object);
                  var si = new joint.shapes.pid.TPObject()
                  si.prop('unitType', 'Sensor');
                  si.resize(30, 30);
                  si.position(center_Point.x - 80, center_Point.y - 16)
                  graph.addCell(si)
                  new_Link_To_Sensor = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_To_Sensor.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'], endDirections: ['right'] })
                  new_Link_To_Sensor.source({ id: s.id, port: 'out_left_1' })
                  new_Link_To_Sensor.target({ id: si.id, port: 'in_right_1' })
                  graph.addCells(new_Link_To_SensorConnector, new_Link_From_SensorConnector, new_Link_To_Sensor)
                  new_Link_To_Sensor.attr('line/targetMarker/d', 'M 0 0')
                  new_Link_To_Sensor.removeLabel(-1)
              }
          }
          else if (left_Point_Distance == second_Min_Value) {
              // BOTTOM AND LEFT
              alert('Please insert SensorConnector further away from bend');
          }
          else {
              // BOTTOM AND RIGHT
              alert('Please insert SensorConnector further away from bend');
          }
      }
      else if (left_Point_Distance == min_Value) {
          let second_Min_Value = Math.min(top_Point_Distance, bottom_Point_Distance, right_Point_Distance)
          if (top_Point_Distance == second_Min_Value) {
              // LEFT AND TOP
              alert('Please insert SensorConnector further away from bend');
          }
          else if (bottom_Point_Distance == second_Min_Value) {
              // BOTTOM AND LEFT
              alert('Please insert SensorConnector further away from bend');
          }
          else {
              // LEFT AND RIGHT
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(right_Center_Point) <= linkView.getClosestPointRatio(left_Center_Point)) {
                  // Connect in to right and out from left
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.SensorConnectorHorizObject()
                  s.prop('unitType', 'SensorConnector');
                  s.prop('isUnit', 'yes');
                  s.resize(30, 1);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y)
                  new_Link_To_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['right'] });

                  new_Link_To_SensorConnector.source(existing_Link_Source_Object);
                  new_Link_To_SensorConnector.target({
                      id: s.id, port: 'in_right_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_To_SensorConnector.attr('line/targetMarker/d', 'M 0 0')

                  new_Link_From_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] })
                  new_Link_From_SensorConnector.source({
                      id: s.id, port: 'out_right_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_SensorConnector.target(existing_Link_Target_Object);
                  var si = new joint.shapes.pid.TPObject()
                  si.prop('unitType', 'Sensor');
                  si.resize(30, 30);
                  si.position(center_Point.x - 16, center_Point.y - 80)
                  graph.addCell(si)
                  new_Link_To_Sensor = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_To_Sensor.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'], endDirections: ['bottom'] })
                  new_Link_To_Sensor.source({ id: s.id, port: 'out_top_1' })
                  new_Link_To_Sensor.target({ id: si.id, port: 'in_bottom_1' })
                  graph.addCells(new_Link_To_SensorConnector, new_Link_From_SensorConnector, new_Link_To_Sensor)
                  new_Link_To_Sensor.attr('line/targetMarker/d', 'M 0 0')
                  new_Link_To_Sensor.removeLabel(-1)
              }
              else {
                  // Connect into left and out of right
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.SensorConnectorHorizObject()
                  s.prop('unitType', 'SensorConnector');
                  s.prop('isUnit', 'yes');
                  s.resize(30, 1);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y)
                  new_Link_To_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['left'] });
                  new_Link_To_SensorConnector.source(existing_Link_Source_Object);
                  new_Link_To_SensorConnector.target({
                      id: s.id, port: 'in_left_1',
                      // anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_To_SensorConnector.attr('line/targetMarker/d', 'M 0 0')

                  new_Link_From_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] });
                  new_Link_From_SensorConnector.source({
                      id: s.id, port: 'out_right_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_SensorConnector.target(existing_Link_Target_Object);
                  var si = new joint.shapes.pid.TPObject()
                  si.prop('unitType', 'Sensor');
                  si.resize(30, 30);
                  si.position(center_Point.x - 16, center_Point.y - 80)
                  graph.addCell(si)
                  new_Link_To_Sensor = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_To_Sensor.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'], endDirections: ['bottom'] });
                  new_Link_To_Sensor.source({ id: s.id, port: 'out_top_1' })
                  new_Link_To_Sensor.target({ id: si.id, port: 'in_bottom_1' })
                  graph.addCells(new_Link_To_SensorConnector, new_Link_From_SensorConnector, new_Link_To_Sensor)
                  new_Link_To_Sensor.attr('line/targetMarker/d', 'M 0 0')
                  new_Link_To_Sensor.removeLabel(-1)
              }
          }
      }
      else {
          // RIGHT and others
          let second_Min_Value = Math.min(top_Point_Distance, bottom_Point_Distance, left_Point_Distance)
          if (top_Point_Distance == second_Min_Value) {
              // RIGHT AND TOP
              alert('Please insert SensorConnector further away from bend');
          }
          else if (bottom_Point_Distance == second_Min_Value) {
              // BOTTOM AND right
              alert('Please insert SensorConnector further away from bend');
          }
          else {
              // LEFT AND RIGHT
              s.attr('leftline/stroke', 'black');
              s.attr('rightline/stroke', 'black');
              // But which is incoming and which is outgoing?
              if (linkView.getClosestPointRatio(right_Center_Point) <= linkView.getClosestPointRatio(left_Center_Point)) {
                  // Connect in to right and out from left
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.SensorConnectorHorizObject()
                  s.prop('unitType', 'SensorConnector');
                  s.prop('isUnit', 'yes');
                  s.resize(30, 1);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y)
                  new_Link_To_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['right'] })

                  new_Link_To_SensorConnector.source(existing_Link_Source_Object);
                  new_Link_To_SensorConnector.target({
                      id: s.id, port: 'in_right_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_To_SensorConnector.attr('line/targetMarker/d', 'M 0 0')

                  new_Link_From_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] })
                  new_Link_From_SensorConnector.source({
                      id: s.id, port: 'out_right_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_SensorConnector.target(existing_Link_Target_Object);
                  var si = new joint.shapes.pid.TPObject()
                  si.prop('unitType', 'Sensor');
                  si.resize(30, 30);
                  si.position(center_Point.x - 16, center_Point.y - 80)
                  graph.addCell(si)
                  new_Link_To_Sensor = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_To_Sensor.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'], endDirections: ['bottom'] });
                  new_Link_To_Sensor.source({ id: s.id, port: 'out_top_1' })
                  new_Link_To_Sensor.target({ id: si.id, port: 'in_bottom_1' })
                  graph.addCells(new_Link_To_SensorConnector, new_Link_From_SensorConnector, new_Link_To_Sensor)
                  new_Link_To_Sensor.attr('line/targetMarker/d', 'M 0 0')
                  new_Link_To_Sensor.removeLabel(-1)
              }
              else {
                  // Connect into left and out of right
                  // But first remove the original link
                  graph.removeCells(link);
                  // And reposition the pipework
                  var s = new joint.shapes.pipework.SensorConnectorHorizObject()
                  s.prop('unitType', 'SensorConnector');
                  s.prop('isUnit', 'yes');
                  s.resize(30, 1);
                  graph.addCell(s);
                  s.position(center_Point.x - 15, center_Point.y)
                  new_Link_To_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, endDirections: ['left'] })

                  new_Link_To_SensorConnector.source(existing_Link_Source_Object);
                  new_Link_To_SensorConnector.target({
                      id: s.id, port: 'in_left_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_To_SensorConnector.attr('line/targetMarker/d', 'M 0 0')

                  new_Link_From_SensorConnector = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  //new_Link_From_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] })
                  new_Link_From_SensorConnector.source({
                      id: s.id, port: 'out_right_1',
                      //anchor: {
                      //    name: 'center'
                      //}
                  });
                  new_Link_From_SensorConnector.target(existing_Link_Target_Object);
                  var si = new joint.shapes.pid.TPObject()
                  si.prop('unitType', 'Sensor');
                  si.resize(30, 30);
                  si.position(center_Point.x - 16, center_Point.y - 80)
                  graph.addCell(si)
                  new_Link_To_Sensor = new joint.shapes.standard.Link({ attrs: { line: { stroke: 'black', strokeWidth: 1 } } });
                  new_Link_To_Sensor.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'], endDirections: ['bottom'] })
                  new_Link_To_Sensor.source({ id: s.id, port: 'out_top_1' })
                  new_Link_To_Sensor.target({ id: si.id, port: 'in_bottom_1' })
                  graph.addCells(new_Link_To_SensorConnector, new_Link_From_SensorConnector, new_Link_To_Sensor)
                  new_Link_To_Sensor.attr('line/targetMarker/d', 'M 0 0')
                  new_Link_To_Sensor.removeLabel(-1)
              }
          }
      }
      if (original_Number == '') {
          new_Link_To_SensorConnector.label(0, { attrs: { 'labelInputDiv': { style: { borderBottom: 'hidden' } } } });
          new_Link_To_SensorConnector.label(0, { attrs: { 'labelInputDiv': { style: { borderTop: 'hidden' } } } });
          new_Link_To_SensorConnector.label(0, { attrs: { 'labelInputDiv': { style: { borderLeft: 'hidden' } } } });
          new_Link_To_SensorConnector.label(0, { attrs: { 'labelInputDiv': { style: { borderRight: 'hidden' } } } });
          new_Link_To_SensorConnector.label(0, { attrs: { 'labelInputDiv': { style: { backgroundColor: 'transparent' } } } });
      }
      new_Link_To_SensorConnector.label(0, { attrs: { 'labelInputDiv': { value: original_Number } } });
      this.stream_Count = this.stream_Count - 1
      //stream_Number_Div.value = stream_Count;
      new_Link_From_SensorConnector.label(0, { attrs: { 'labelInputDiv': { value: this.stream_Count - 1 } } });
      new_Link_To_SensorConnector.prop('CustomName', original_Number)

      new_Link_To_Sensor.prop('CustomName', '')
      new_Link_To_SensorConnector.router('manhattan', {
          startDirections: [new_Link_To_SensorConnector.source().port.split('_')[1]],
          endDirections: [new_Link_To_SensorConnector.target().port.split('_')[1]],
          padding: 10, step: 10
      })
      new_Link_From_SensorConnector.router('manhattan', {
          startDirections: [new_Link_From_SensorConnector.source().port.split('_')[1]],
          endDirections: [new_Link_From_SensorConnector.target().port.split('_')[1]],
          padding: 10, step: 10
      })

      if (original_Stream_Properties != 'No Properties Exist') {
          new_Link_To_SensorConnector.prop({ 'stream_Properties': original_Stream_Properties })
          new_Link_From_SensorConnector.prop({ 'stream_Properties': original_Stream_Properties })
      }
      new_Link_From_SensorConnector.label(0, { attrs: { 'labelInputDiv': { value: '' } } });
      new_Link_From_SensorConnector.prop('CustomName', '');
      new_Link_From_SensorConnector.label(0, { attrs: { 'labelInputDiv': { style: { borderBottom: 'hidden' } } } });
      new_Link_From_SensorConnector.label(0, { attrs: { 'labelInputDiv': { style: { borderTop: 'hidden' } } } });
      new_Link_From_SensorConnector.label(0, { attrs: { 'labelInputDiv': { style: { borderLeft: 'hidden' } } } });
      new_Link_From_SensorConnector.label(0, { attrs: { 'labelInputDiv': { style: { borderRight: 'hidden' } } } });
      new_Link_From_SensorConnector.label(0, { attrs: { 'labelInputDiv': { style: { backgroundColor: 'transparent' } } } });
      //new_Link_From_SensorConnector.prop('CustomName', new_Link_To_SensorConnector.prop('CustomName'))
      let new_LinkView1 = paper.findViewByModel(new_Link_To_SensorConnector)
      //Add vertices to the turning points
      let new_link1_Svg_String = new_LinkView1.getSerializedConnection();
      new_link1_Svg_String = new_link1_Svg_String.replace('M ', '');

      let source_Point1 = new_LinkView1.model.getSourcePoint();
      let target_Point1 = new_LinkView1.model.getTargetPoint();

      new_link1_Path_Array = new_link1_Svg_String.split(" L ");
      let link1_Coordinates = [];
      for (let i = 0; i < new_link1_Path_Array.length; i++) {
          link1_Coordinates.push(new_link1_Path_Array[i].split(" "))
      }
      for (let i = 0; i < link1_Coordinates.length; i++) {
          let vertex1 = { x: link1_Coordinates[i][0], y: link1_Coordinates[i][1] }
          if (!(((Math.abs(source_Point1.x - vertex1.x) < 5) && (Math.abs(source_Point1.y - vertex1.y) < 5)) || ((Math.abs(target_Point1.x - vertex1.x) < 5) && (Math.abs(target_Point1.y - vertex1.y) < 5)))) {
              new_LinkView1.addVertex(parseInt(vertex1.x, 10), parseInt(vertex1.y, 10))
          }
      }
      new_LinkView1.removeRedundantLinearVertices()


      let new_LinkView2 = paper.findViewByModel(new_Link_From_SensorConnector)
      //Add vertices to the turning points
      let new_link2_Svg_String = new_LinkView2.getSerializedConnection();
      new_link2_Svg_String = new_link2_Svg_String.replace('M ', '');

      let source_Point2 = new_LinkView2.model.getSourcePoint();
      let target_Point2 = new_LinkView2.model.getTargetPoint();

      new_link2_Path_Array = new_link2_Svg_String.split(" L ");
      let link2_Coordinates = [];
      for (let i = 0; i < new_link2_Path_Array.length; i++) {
          link2_Coordinates.push(new_link2_Path_Array[i].split(" "))
      }
      for (let i = 0; i < link2_Coordinates.length; i++) {
          let vertex2 = { x: link2_Coordinates[i][0], y: link2_Coordinates[i][1] }
          if (!(((Math.abs(source_Point2.x - vertex2.x) < 5) && (Math.abs(source_Point2.y - vertex2.y) < 5)) || ((Math.abs(target_Point2.x - vertex2.x) < 5) && (Math.abs(target_Point2.y - vertex2.y) < 5)))) {
              new_LinkView2.addVertex(parseInt(vertex2.x, 10), parseInt(vertex2.y, 10))
          }
      }
      new_LinkView2.removeRedundantLinearVertices()

      if ((new_Link_To_SensorConnector.source().id) && (graph.getCell(new_Link_To_SensorConnector.source().id).prop('unitType') == 'pipework')) {

          if (new_Link_To_SensorConnector.source().port == 'out_top_1') {
              graph.getCell(new_Link_To_SensorConnector.source().id).attr('topline/stroke', 'black')
              new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['top'] })
          }
          if (new_Link_To_SensorConnector.source().port == 'out_bottom_1') {
              graph.getCell(new_Link_To_SensorConnector.source().id).attr('bottomline/stroke', 'black')
              new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['bottom'] })
          }
          if (new_Link_To_SensorConnector.source().port == 'out_right_1') {
              graph.getCell(new_Link_To_SensorConnector.source().id).attr('rightline/stroke', 'black')
              new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['right'] })

          }
          if (new_Link_To_SensorConnector.source().port == 'out_left_1') {
              graph.getCell(new_Link_To_SensorConnector.source().id).attr('leftline/stroke', 'black')
              new_Link_To_SensorConnector.router({ name: 'manhattan', perpendicular: true, step: 10, padding: 10, maximumLoops: 100000, startDirections: ['left'] })
          }
      }

      if ((new_Link_From_SensorConnector.target().id) && ((graph.getCell(new_Link_From_SensorConnector.target().id).prop('unitType') == 'SensorConnector') || (graph.getCell(new_Link_From_SensorConnector.target().id).prop('unitType') == 'valve'))) {
          new_Link_From_SensorConnector.attr('line/targetMarker/d', 'M 0 0')
      }

      new_Link_To_SensorConnector.attr('line/targetMarker/d', 'M 0 0')

      commandManager.storeBatchCommand()

  }

  on_Screen_Menu_Focus(focus_Status) {
      let paper_Display
      let div_Colour
      if (focus_Status) {
          paper_Display = 'none'
          div_Colour = 'lightgray'
      }
      else {
          paper_Display = 'block'
          div_Colour = 'white'

      }

      // Update the background/div colours to highlight/unhighlight the menu
      document.getElementById('paper-container').style.display = paper_Display
      const textOverlay = document.getElementById('text-overlay-container');
      if (textOverlay) textOverlay.style.display = paper_Display;
      let stream_Input_Divs = document.getElementsByClassName('joint-link-label-input-divs')
      for (let i = 0; i < stream_Input_Divs.length; i++) {
          stream_Input_Divs[i].style.background = div_Colour
      }
      let unit_Input_Divs = document.getElementsByClassName('unit-label-inputs')
      for (let i = 0; i < unit_Input_Divs.length; i++) {
          unit_Input_Divs[i].style.background = div_Colour
      }
  }


  feed_Tag_Wizard(element, type) {
    this.displayFeedTagPopup(element, 'Feed', true)
    this.on_Screen_Menu_Focus(true)
  }

  RX_Spec_Wizard(element) {
    this.displayRXSpecPopup(element, "RX", true)
    this.on_Screen_Menu_Focus(true)
  }

  //function to export the graph to child components
  getGraph() {
    return this.graph;
  }

  // Add equipment by type (for AI chat integration).
  // Optional x, y override default viewport-center placement.
  // Pass autoCenter=false when placing multiple units (e.g. subsystem) to avoid canvas jumping.
  addEquipmentByType(equipmentType, x, y, autoCenter = true) {
    const shapeMap = {
      'Pump': 'pfd.PumpObject',
      'Vessel': 'pfd.VesselObject',
      'Feed': 'pfd.FeedObject',
      'HeatExchanger': 'pfd.HeatXObject',
      'MixerSplitter': 'pipework.MixerSplitterObject',
      'Crusher': 'pfd.CrusherConeTypeISOObject',
      'Filter': 'pfd.Filter3Object',
      'Settler': 'pfd.SettlerObject',
      'AgitatedVessel': 'pfd.agitatedVesselObject',
      'Cyclone': 'pfd.InsulatedConeObject',
      'Screen': 'pfd.SolidSeparatorObject',
      'Flotation': 'pfd.agitatedVesselObject',
      'Thickener': 'pfd.SettlerObject',
      'Dryer': 'pfd.DrumObject',
      'Kiln': 'pfd.DrumObject',
      'Crystallizer': 'pfd.VesselObject',
      'Evaporator': 'pfd.VesselObject',
      'DistillationColumn': 'pfd.FixedBedColumnObject',
      'AbsorptionColumn': 'pfd.WaterWashColumnObject',
      'Reactor': 'pfd.agitatedVesselObject',
      'FlashDrum': 'pfd.VesselObject'
    };

    const sizeMap = {
      'Pump': { width: 40, height: 40 },
      'Vessel': { width: 60, height: 90 },
      'Feed': { width: 80, height: 30 },
      'HeatExchanger': { width: 60, height: 60 },
      'MixerSplitter': { width: 40, height: 40 },
      'Crusher': { width: 50, height: 60 },
      'Filter': { width: 80, height: 40 },
      'Settler': { width: 80, height: 50 },
      'AgitatedVessel': { width: 60, height: 90 },
      'Cyclone': { width: 40, height: 60 },
      'Screen': { width: 80, height: 40 },
      'Flotation': { width: 60, height: 50 },
      'Thickener': { width: 80, height: 60 },
      'Dryer': { width: 80, height: 50 },
      'Kiln': { width: 100, height: 40 },
      'Crystallizer': { width: 60, height: 80 },
      'Evaporator': { width: 50, height: 80 },
      'DistillationColumn': { width: 40, height: 100 },
      'AbsorptionColumn': { width: 40, height: 100 },
      'Reactor': { width: 60, height: 80 },
      'FlashDrum': { width: 50, height: 70 }
    };

    const shapeType = shapeMap[equipmentType];
    if (!shapeType) {
      console.warn('Unknown equipment type:', equipmentType);
      return null;
    }

    // Get the shape class from joint.shapes namespace
    const typeParts = shapeType.split('.');
    let ShapeClass = joint.shapes;
    for (const part of typeParts) {
      ShapeClass = ShapeClass[part];
      if (!ShapeClass) {
        console.warn('Shape class not found:', shapeType);
        return null;
      }
    }

    const size = sizeMap[equipmentType] || { width: 60, height: 60 };
    const center = this.paperScroller.getVisibleArea().center();
    const finalX = x !== undefined ? x : center.x - size.width / 2;
    const finalY = y !== undefined ? y : center.y - size.height / 2;

    // Create the shape starting 150px above final position (for drop animation)
    const DROP = 150;
    const shape = new ShapeClass({
      position: { x: finalX, y: finalY - DROP },
      size: size
    });

    // Add to graph (this triggers paper to render the view)
    this.graph.addCell(shape);

    // Call graphAdd to set up all unit properties, labels, etc. (same as drag & drop)
    if (this.graphAdd) {
      this.graphAdd(shape);
    }

    // Drop animation via rAF with spring easing
    const t0 = performance.now();
    const tick = (now) => {
      const t = Math.min((now - t0) / 1200, 1);
      const ease = 1 - Math.exp(-6 * t) * Math.cos(2.2 * Math.PI * t);
      shape.set('position', { x: finalX, y: finalY - DROP + DROP * ease });
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);

    // Opacity fade-in via render:done event
    this.paper.once('render:done', () => {
      const el = this.paper.el.querySelector(`[model-id="${shape.id}"]`);
      if (!el) { if (autoCenter) this.paperScroller.centerElement(shape); return; }
      el.style.opacity = '0';
      void el.offsetHeight;
      el.style.transition = 'opacity 0.9s ease-out';
      el.style.opacity = '1';
      setTimeout(() => {
        el.style.transition = '';
        el.style.opacity = '';
        if (autoCenter) this.paperScroller.centerElement(shape);
      }, 950);
    });

    return shape.id;
  }



}

export default KitchenSinkService
